<template>
  <div class="pest_wiki_detail">
    <div class="wiki-details-wrapper">
      <pest_mes :equipment="equipment" :product="product" :contains="contains"></pest_mes>
      <Hot_question></Hot_question>
      <Connect_item :equipment="equipment" :isPhoneSize="isPhoneSize" :product_id="product.product_id" :jump_to_detail="true"></Connect_item>
      <Pest_advice></Pest_advice>
      <div id="detail_div_touchstart_0" ref="advantage" @touchstart="touchstart($event)">
        <Connect_us :equipment="equipment"
                    :title="'联系我们'"
                    :product_id="product.product_id"
                    :status2="status2"
                    :isPhoneSize="isPhoneSize"
                    :jump_to_detail="true" ref="advantage">
        </Connect_us>
      </div>

      <div class="article-section">
        <div class="article-title purple-2 f19 mb5">相关文章</div>
        <hr class="light-separator mt5 mb15">
        <div class="article-cell flex-row">
          <div class="article-title">没有相关文章</div>
        </div>
        <hr class="light-separator mt18">
      </div>
    </div>
    <div v-if="$route.params.id == 2" id="main-body2">
      <div id="detail_div_hidePestDetail_overlay" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_wrapper" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_wrapper" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png"
              class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-18.jpg" alt="蟑螂"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">德国小蠊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>德国蟑螂、德国姬蠊、小强</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Blattella germanica/German cockroach</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊科姬蠊亚科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      成年的德国小蠊可长至13-16mm，它的颜色是浅棕色或棕褐色的，幼虫颜色几乎黑色。位于前胸背板有两条黑色的条纹。虽然德国小蠊有翅膀，但它们很少飞行，更倾向于爬行。<br>
                      蟑螂繁殖速度很快，并且是群居性动物。成虫在孵化后60天即可立即繁殖，一只雌性德国小蠊一年可繁殖10,000只后代。德国小蠊喜欢温暖、潮湿、多缝隙、有丰富食物的地方。所以主要出现在热源、水源、和木结构物品的附近。当种群大量存在时，可能会发现轻度的，或者是一些人所说的“霉味”。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蟑螂" src="@/assets/img/resources/uploads/2-16.jpg" style="width: 49%;">
                    <img src="@/assets/img/resources/uploads/3-17.jpg" style="width: 49%;" alt="蟑螂"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img alt="蟑螂" src="@/assets/img/resources/uploads/2-16.jpg"> <img
                  alt="蟑螂" src="@/assets/img/resources/uploads/3-17.jpg">
                  <p>
                  成年的德国小蠊可长至13-16mm，它的颜色是浅棕色或棕褐色的，幼虫颜色几乎黑色。位于前胸背板有两条黑色的条纹。虽然德国小蠊有翅膀，但它们很少飞行，更倾向于爬行。<br>
                  蟑螂繁殖速度很快，并且是群居性动物。成虫在孵化后60天即可立即繁殖，一只雌性德国小蠊一年可繁殖10,000只后代。德国小蠊喜欢温暖、潮湿、多缝隙、有丰富食物的地方。所以主要出现在热源、水源、和木结构物品的附近。当种群大量存在时，可能会发现轻度的，或者是一些人所说的“霉味”。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-19.jpg" alt="蟑螂"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">美洲大蠊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>美洲家蠊、美洲蟑螂、红蠊</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Periplaneta americana/American cockroach</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊科大蠊属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">美洲大蠊体型较大，成虫长度约为50mm，它的颜色是红棕色或红褐色，其前胸背板有较大的蝶形褐色斑纹，斑纹后缘有完整的黄色带纹。<br>
                      美洲大蠊是一种非常活跃的夜间昆虫。一只雌性美洲大蠊每隔几周便可产出一个卵鞘，一生可产30～60个卵鞘。它们都可以飞翔，喜欢温暖潮湿的地方，会去洗手间，厨房，洗衣房和地下室。美洲蟑螂会食用奶酪，啤酒，茶，皮革，烘焙产品，书籍装订中的淀粉，手稿，胶水，头发，死亡动物等，它们甚至还会吃掉或死或伤的同类。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蟑螂"
                                                                                   src="@/assets/img/resources/uploads/2-86.jpg"
                                                                                   style="width: 49%;"> <img alt="蟑螂"
                                                                                                             src="@/assets/img/resources/uploads/1-19.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img alt="蟑螂" src="@/assets/img/resources/uploads/2-86.jpg"> <img
                  src="@/assets/img/resources/uploads/1-19.jpg" alt="蟑螂">
                  <p>美洲大蠊体型较大，成虫长度约为50mm，它的颜色是红棕色或红褐色，其前胸背板有较大的蝶形褐色斑纹，斑纹后缘有完整的黄色带纹。<br>
                    美洲大蠊是一种非常活跃的夜间昆虫。一只雌性美洲大蠊每隔几周便可产出一个卵鞘，一生可产30～60个卵鞘。它们都可以飞翔，喜欢温暖潮湿的地方，会去洗手间，厨房，洗衣房和地下室。美洲蟑螂会食用奶酪，啤酒，茶，皮革，烘焙产品，书籍装订中的淀粉，手稿，胶水，头发，死亡动物等，它们甚至还会吃掉或死或伤的同类。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-20.jpg" alt="蟑螂"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黑胸大蠊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>本土蟑螂、小强、偷油婆</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Periplaneta fuliginosa/Smokybrown cockroach</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊科大蠊属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">黑胸大蠊成虫有光泽的外观，均匀呈黑色，红褐色，长度可达38毫米。早期的若虫阶段在胸部和尖端上都有白色的条纹。<br>
                      黑胸大蠊平均寿命超过一年，通常存在于地下室和地下层，以及漏水的屋顶、暴露的垃圾和下水道开口。容易被内部灯光吸引，随后通过窗户，门和其他进入家中的缝隙进入家中，会飞行。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蟑螂"
                                                                                   src="@/assets/img/resources/uploads/3-18.jpg"
                                                                                   style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/2-17.jpg" style="width: 49%;"
                    alt="蟑螂"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/3-18.jpg"> <img alt="蟑螂"
                                                                                                      src="@/assets/img/resources/uploads/2-17.jpg">
                  <p>黑胸大蠊成虫有光泽的外观，均匀呈黑色，红褐色，长度可达38毫米。早期的若虫阶段在胸部和尖端上都有白色的条纹。<br>
                    黑胸大蠊平均寿命超过一年，通常存在于地下室和地下层，以及漏水的屋顶、暴露的垃圾和下水道开口。容易被内部灯光吸引，随后通过窗户，门和其他进入家中的缝隙进入家中，会飞行。</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 3" id="main-body3">
      <div id="detail_div_hidePestDetail_0" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_0" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_1" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/Picture1-1.jpg" alt="白蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">台湾乳白蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>家白蚁、台湾家白蚁、飞蚂蚁、白蚂蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Coptotermes formosanus</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊目（等翅目）鼻白蚁科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      台湾乳白蚁有翅成虫（婚飞蚁）长约半英寸，呈黄棕色。兵蚁头成椭圆形，囟孔上窄下宽，卵圆形，大而显著。兵蚁受惊时，头部前段的囟会流出大量乳白色的酸性液体，用以抵御外敌，故有乳白蚁之称。<br>
                      台湾乳白蚁是世界上危害最大的白蚁，容易入侵高层建筑。家白蚁种群庞大，往往有主巢、副巢（分级巢）之分，扩散面积广。每年5-7月份是台湾乳白蚁的分飞（婚飞）季，多发生于大雨前后闷热的傍晚，容易被室内灯光吸引。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;">
                    <img alt="白蚁" src="@/assets/img/resources/uploads/notitle-6.jpg" style="width: 49%;">
                    <img src="@/assets/img/resources/uploads/notitle-5-4.jpg" style="width: 49%;"
                    alt="白蚁">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img alt="白蚁" src="@/assets/img/resources/uploads/notitle-6.jpg">
                  <img alt="白蚁" src="@/assets/img/resources/uploads/notitle-5-4.jpg">
                  <p>台湾乳白蚁有翅成虫（婚飞蚁）长约半英寸，呈黄棕色。兵蚁头成椭圆形，囟孔上窄下宽，卵圆形，大而显著。兵蚁受惊时，头部前段的囟会流出大量乳白色的酸性液体，用以抵御外敌，故有乳白蚁之称。<br>
                    台湾乳白蚁是世界上危害最大的白蚁，容易入侵高层建筑。家白蚁种群庞大，往往有主巢、副巢（分级巢）之分，扩散面积广。每年5-7月份是台湾乳白蚁的分飞（婚飞）季，多发生于大雨前后闷热的傍晚，容易被室内灯光吸引。
                  </p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/Picture4.jpg" alt="白蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黄胸散白蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>飞蚂蚁、白蚂蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Reticulitermes speratus</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊目（等翅目）鼻白蚁科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      黄胸散白蚁最典型的特征是分飞蚁的前胸背板（头部往下一小节）呈黄色。头部的形状近似长方形，且两侧的边缘相互近似平行；前胸背板前缘比后缘宽；腹部毛浓密，呈淡黄色。<br>
                      每年2-4月份是其分飞季，如果气压骤然下降，气温达18-20℃，黄胸散白蚁分飞蚁便会大量分飞，喜欢在中午前后闷热的天气分飞1-2次。<br>
                      黄胸散白蚁栖居分散，不筑大巢，防治比较困难。危害部位集中在低层区域。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="白蚁"
                                                                                   src="@/assets/img/resources/uploads/Picture5.jpg"
                                                                                   style="width: 49%;">
                    <img src="@/assets/img/resources/uploads/Picture6.jpg" alt="白蚁"
                         style="width: 49%;"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/Picture5.jpg"> <img alt="白蚁"
                                                                                                          src="@/assets/img/resources/uploads/Picture6.jpg">
                  <p>黄胸散白蚁最典型的特征是分飞蚁的前胸背板（头部往下一小节）呈黄色。头部的形状近似长方形，且两侧的边缘相互近似平行；前胸背板前缘比后缘宽；腹部毛浓密，呈淡黄色。<br>
                    每年2-4月份是其分飞季，如果气压骤然下降，气温达18-20℃，黄胸散白蚁分飞蚁便会大量分飞，喜欢在中午前后闷热的天气分飞1-2次。<br>
                    黄胸散白蚁栖居分散，不筑大巢，防治比较困难。危害部位集中在低层区域。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/Picture7.jpg" alt="白蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黑胸散白蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>白蚂蚁、飞蚂蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Reticulitermes chinensis</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蜚蠊目（等翅目）鼻白蚁科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">黑胸散白蚁有翅成虫的头、前胸背板呈深栗褐色，因此而得名。头部正面长而扁，形状近似长方形，两侧边缘相互近似平行。<br>
                      黑胸散白蚁的分飞期为4-5月，中午前后分飞1-2次。其分飞孔多呈长条形，长2-5cm，宽0.2-0.3cm，建筑物内的分飞孔多在木柱、门框、窗框上。黑胸对生活环境的水湿要求较高，通常将巢筑在离水槽、厨房、卫生间、或其他水源较近的地方；黑胸破坏主要集中在低层区域（但也可危害到较高部位），其巢外的木材表面有用泥做成的蚁路，通向四周，被发现时往往已造成较大的危害，需要及时进行防治。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/2-85.jpg" style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/3-80.jpg" style="width: 49%;"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-85.jpg" alt="白蚁"> <img alt="白蚁"
                                                                                                               src="@/assets/img/resources/uploads/3-80.jpg">
                  <p>黑胸散白蚁有翅成虫的头、前胸背板呈深栗褐色，因此而得名。头部正面长而扁，形状近似长方形，两侧边缘相互近似平行。<br>
                    黑胸散白蚁的分飞期为4-5月，中午前后分飞1-2次。其分飞孔多呈长条形，长2-5cm，宽0.2-0.3cm，建筑物内的分飞孔多在木柱、门框、窗框上。黑胸对生活环境的水湿要求较高，通常将巢筑在离水槽、厨房、卫生间、或其他水源较近的地方；黑胸破坏主要集中在低层区域（但也可危害到较高部位），其巢外的木材表面有用泥做成的蚁路，通向四周，被发现时往往已造成较大的危害，需要及时进行防治。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$route.params.id == 4" id="main-body4">
      <div id="detail_div_hidePestDetail_overlay" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_1" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_back" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-3.jpg" alt="老鼠"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">小家鼠</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>小鼠、小耗子</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Mus musculus/House mouse</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>啮齿目鼠科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      小家鼠是鼠科中的小型鼠，体长60-90mm，尾长等于或短于体长，后足长小于17mm，耳短，前折达不到眼部，声音是高亢的吱吱声。毛色变化很大，背毛由灰褐色至黑灰色，腹毛由纯白到灰黄。<br>
                      小家鼠以夜间活动为主，尤其在晨昏活动最频繁。它们尤其喜好面粉及面制食品，对塑料袋小包装、纸箱等破坏性较大。由于体型小，代谢率高，它必须不停寻找食物，但每次食量很小，仅0.1克左右，并不断更换觅食场所。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="老鼠"
                                                                                   src="@/assets/img/resources/uploads/2-3.jpg"
                                                                                   style="width: 49%;"> <img alt="老鼠"
                                                                                                             src="@/assets/img/resources/uploads/3-1.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-3.jpg"> <img
                  src="@/assets/img/resources/uploads/3-1.jpg">
                  <p>小家鼠是鼠科中的小型鼠，体长60-90mm，尾长等于或短于体长，后足长小于17mm，耳短，前折达不到眼部，声音是高亢的吱吱声。毛色变化很大，背毛由灰褐色至黑灰色，腹毛由纯白到灰黄。<br>
                    小家鼠以夜间活动为主，尤其在晨昏活动最频繁。它们尤其喜好面粉及面制食品，对塑料袋小包装、纸箱等破坏性较大。由于体型小，代谢率高，它必须不停寻找食物，但每次食量很小，仅0.1克左右，并不断更换觅食场所。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/notitle-4.jpg" alt=""
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">褐家鼠</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>挪威鼠</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Rattus norvegicus/Brown rat/Norwegian rat</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>啮齿目鼠科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      褐家鼠颜色呈棕色或灰色，体粗壮，体长150~250mm，体重约220-280克，尾长明显短于体长，尾毛稀疏，耳短而厚，向前翻不到眼睛，是家栖鼠中较大的一种。<br>
                      褐家鼠几乎无所不食，但更倾向于含水丰富的食物。它们也是善于打洞的动物，鼠洞长可达180－300cm，深50cm，能够钻过任何大于1.25公分的孔隙，也可通过抽水马桶潜入建筑物内。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/notitle-5.jpg" style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/Picture10.jpeg" style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/notitle-5.jpg"> <img
                  src="@/assets/img/resources/uploads/Picture10.jpeg">
                  <p>褐家鼠颜色呈棕色或灰色，体粗壮，体长150~250mm，体重约220-280克，尾长明显短于体长，尾毛稀疏，耳短而厚，向前翻不到眼睛，是家栖鼠中较大的一种。<br>
                    褐家鼠几乎无所不食，但更倾向于含水丰富的食物。它们也是善于打洞的动物，鼠洞长可达180－300cm，深50cm，能够钻过任何大于1.25公分的孔隙，也可通过抽水马桶潜入建筑物内。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/notitle-4-1.jpg" alt="老鼠"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黄胸鼠</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>屋顶鼠</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Rattus flavipectus/Roof rat</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>啮齿目鼠科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      黄胸鼠体长160-240mm，尾巴长于头和身体的总长，体重150-200g，背毛棕褐或黄褐色，并杂有黑色，鼻尖、耳大。体型与褐家鼠相似，但比褐家鼠瘦小，身体更纤细。<br>
                      黄胸鼠非常善于攀登，还能够垂直跳过60cm。黄胸鼠是杂食动物并且倾向于植物性食物，如蔬菜、水果、稻谷等，它们的饮食含水量很高。喜欢栖息于高层隐蔽场所，如屋顶、天花板、树枝上以及杂物堆。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="老鼠"
                                                                                   src="@/assets/img/resources/uploads/6.jpg"
                                                                                   style="width: 49%;"> <img alt="老鼠"
                                                                                                             src="@/assets/img/resources/uploads/notitle-5-1.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/6.jpg"> <img alt="老鼠"
                                                                                                   src="@/assets/img/resources/uploads/notitle-5-1.jpg">
                  <p>黄胸鼠体长160-240mm，尾巴长于头和身体的总长，体重150-200g，背毛棕褐或黄褐色，并杂有黑色，鼻尖、耳大。体型与褐家鼠相似，但比褐家鼠瘦小，身体更纤细。<br>
                    黄胸鼠非常善于攀登，还能够垂直跳过60cm。黄胸鼠是杂食动物并且倾向于植物性食物，如蔬菜、水果、稻谷等，它们的饮食含水量很高。喜欢栖息于高层隐蔽场所，如屋顶、天花板、树枝上以及杂物堆。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 5" id="main-body5">
      <div id="detail_div_hidePestDetail_2" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_2" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_3" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-8.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">小黄家蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>法老蚁、厨蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Monomorium pharaonic/Pharaoh ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科小家蚁属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚂蚁"
                                                                                   src="@/assets/img/resources/uploads/2-8.jpg"
                                                                                   style="width: 49%;"> <img alt="蚂蚁"
                                                                                                             src="@/assets/img/resources/uploads/3-5.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-8.jpg"> <img alt="蚂蚁"
                                                                                                     src="@/assets/img/resources/uploads/3-5.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-9.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">路舍蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>行道蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Tetramorium caespitum/Pavement ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科路舍蚁属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">路舍蚁长约2.5到3毫米，呈褐黄色，触角及足为黄色。头和胸部具细密的纵长条纹，触角有12节。<br>
                      路舍蚁常栖息在居民住宅附近，人行道的下方及其两侧。地下室或车库地面出现数处土堆，则可能有路舍蚁在此扎根了。一般路舍蚁会在这些地方附近寻找食物，如糖果和昆虫尸体。地基，地下室地板和墙壁上的裂缝可能是他们进入室内最初的通道。室内的食物碎屑，垃圾和敞口的食品容器会使它们滞留并构成害虫问题。如果受到刺激，路舍蚁会叮咬人类，但通常情况下它比较温和。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/notitle-5-2.jpg" style="width: 49%;">
                    <img src="@/assets/img/resources/uploads/3-6.jpg" style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/notitle-5-2.jpg" alt="蚂蚁"> <img
                  alt="蚂蚁"
                  src="@/assets/img/resources/uploads/3-6.jpg">
                  <p>路舍蚁长约2.5到3毫米，呈褐黄色，触角及足为黄色。头和胸部具细密的纵长条纹，触角有12节。<br>
                    路舍蚁常栖息在居民住宅附近，人行道的下方及其两侧。地下室或车库地面出现数处土堆，则可能有路舍蚁在此扎根了。一般路舍蚁会在这些地方附近寻找食物，如糖果和昆虫尸体。地基，地下室地板和墙壁上的裂缝可能是他们进入室内最初的通道。室内的食物碎屑，垃圾和敞口的食品容器会使它们滞留并构成害虫问题。如果受到刺激，路舍蚁会叮咬人类，但通常情况下它比较温和。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-10.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">大头蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>无</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Pheidole/Big-headed ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科大头蚁属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      大头蚁（兵蚁）有一个醒目的大头，头的前半部有纹路，后半部光滑。腰身和头部之间的区分十分明显，同时腰部有一对较短的上突棘刺。通体有稀疏的毛。长约4毫米，呈黄褐色到红褐色乃至黑色。<br>
                      大头蚁属是蚁科第二大属，仅次于蚁亚科弓背蚁属。分布范围广，遍布全球各地。大头蚁属常用的捕猎方式是大鄂撕咬，无论是兵蚁还是工蚁，都具有一对锋利且有力的大鄂，这是它们捕猎的有力武器。大头蚁的触角一旦接触到猎物，便会张开大鄂，牢牢咬住猎物，对猎物进行五马分尸。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚂蚁"
                                                                                   src="@/assets/img/resources/uploads/2-9.jpg"
                                                                                   style="width: 49%;"> <img alt="蚂蚁"
                                                                                                             src="@/assets/img/resources/uploads/3-7.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-9.jpg" alt="蚂蚁"> <img alt="蚂蚁"
                                                                                                              src="@/assets/img/resources/uploads/3-7.jpg">
                  <p>大头蚁（兵蚁）有一个醒目的大头，头的前半部有纹路，后半部光滑。腰身和头部之间的区分十分明显，同时腰部有一对较短的上突棘刺。通体有稀疏的毛。长约4毫米，呈黄褐色到红褐色乃至黑色。<br>
                    大头蚁属是蚁科第二大属，仅次于蚁亚科弓背蚁属。分布范围广，遍布全球各地。大头蚁属常用的捕猎方式是大鄂撕咬，无论是兵蚁还是工蚁，都具有一对锋利且有力的大鄂，这是它们捕猎的有力武器。大头蚁的触角一旦接触到猎物，便会张开大鄂，牢牢咬住猎物，对猎物进行五马分尸。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-11.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">臭蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>酸臭蚁、烂椰子蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Dolichoderinae/odorous house ant/stink ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科臭蚁亚科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      臭蚁亚科下有许多属。多呈深褐色。它的腹柄节为单节，腹部末端有裂縫状的孔，从中会产生一种独特的刺激性臭味。臭蚁一般不叮咬人。不像针蚁亚科或家蚁亚科拥有螯针，臭蚁依靠腹部末端的腺体分泌化学物质以抵御攻击。散发出的刺激性气味被形容像烂椰子或坏掉的奶酪的味道。<br>
                      臭蚁在户外常在地面堆放的物体下面筑巢，比如盆栽，堆放的木材，砖块等物品下方，或在树上松散的树皮下定居。住宅内部，墙壁内部、地毯下方以及其他合适的空隙或空间都可能成为臭蚁建巢的地方。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚂蚁"
                                                                                   src="@/assets/img/resources/uploads/notitle-5-3.jpg"
                                                                                   style="width: 49%;">
                    <img src="@/assets/img/resources/uploads/3-8.jpg" alt="蚂蚁"
                         style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/notitle-5-3.jpg"> <img alt="蚂蚁"
                                                                                                         src="@/assets/img/resources/uploads/3-8.jpg">
                  <p>
                    臭蚁亚科下有许多属。多呈深褐色。它的腹柄节为单节，腹部末端有裂縫状的孔，从中会产生一种独特的刺激性臭味。臭蚁一般不叮咬人。不像针蚁亚科或家蚁亚科拥有螯针，臭蚁依靠腹部末端的腺体分泌化学物质以抵御攻击。散发出的刺激性气味被形容像烂椰子或坏掉的奶酪的味道。<br>
                    臭蚁在户外常在地面堆放的物体下面筑巢，比如盆栽，堆放的木材，砖块等物品下方，或在树上松散的树皮下定居。住宅内部，墙壁内部、地毯下方以及其他合适的空隙或空间都可能成为臭蚁建巢的地方。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/notitle-4-2.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">红火蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>火蚁、入侵红火蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Solenopsis invicta/Red Imported Fire Ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科火蚁属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      红火蚁头部为铜棕色，身体为红褐色。工蚁的平均长度可达2-6毫米，下颚骨很发达，有4-5颗牙齿且种类各异。身体有明显的二分式结构并由大量竖起毛发覆盖。<br>
                      源于南美，红火蚁是世界自然保护联盟收录的最具有破坏力的入侵生物之一。红火蚁蚁巢为地栖型，成熟蚁巢会以土壤堆出高约10～30cm直径约30～50cm的蚁丘。蚁后寿命约6～7年，职蚁、工蚁和兵蚁，寿命约1～6个月。红火蚁攻击性强，当受到威胁时，它们会发出致命攻击，受叮咬时会形成白色脓包，引起持续疼痛。撕咬过程会引起短时疼痛，但其毒液会引起持续疼痛，形成脓包。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚂蚁"
                                                                                   src="@/assets/img/resources/uploads/3-9.jpg"
                                                                                   style="width: 49%;"> <img alt="蚂蚁"
                                                                                                             src="@/assets/img/resources/uploads/2-87.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/3-9.jpg"> <img alt="蚂蚁"
                                                                                                     src="@/assets/img/resources/uploads/2-87.jpg">
                  <p>红火蚁头部为铜棕色，身体为红褐色。工蚁的平均长度可达2-6毫米，下颚骨很发达，有4-5颗牙齿且种类各异。身体有明显的二分式结构并由大量竖起毛发覆盖。<br>
                    源于南美，红火蚁是世界自然保护联盟收录的最具有破坏力的入侵生物之一。红火蚁蚁巢为地栖型，成熟蚁巢会以土壤堆出高约10～30cm直径约30～50cm的蚁丘。蚁后寿命约6～7年，职蚁、工蚁和兵蚁，寿命约1～6个月。红火蚁攻击性强，当受到威胁时，它们会发出致命攻击，受叮咬时会形成白色脓包，引起持续疼痛。撕咬过程会引起短时疼痛，但其毒液会引起持续疼痛，形成脓包。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-12.jpg" alt="蚂蚁"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">弓背蚁</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>木匠蚁、木蚁</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Camponotus/Carpenter ant</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚁科弓背蚁属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      弓背蚁可长达3.4-13毫米，多呈黑色，也有一些种类略呈红色和黄色。弓背蚁的工蚁有较大的下颚，其胸腔平滑，呈浑圆形状，腹柄处有明显单节。下颚有5-8颗牙齿。<br>
                      弓背蚁必须有恒定的水源才能生存，喜欢湿度较高的地方通常将巢筑在潮湿的木头里面。筑巢时他们会把木屑掏出来以作通道，这也是为何它们也被称为木匠蚁。横梁、地板或墙壁中都有可能筑巢。但它们不以木材为食，反而偏爱像树蜜以及蚜虫等昆虫分泌物的糖类液体，也以昆虫尸体及血液为食。家中如有弓背蚁筑巢，可能还能听到它们活动时的“沙沙声”。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚂蚁"
                                                                                   src="@/assets/img/resources/uploads/2-10.jpg"
                                                                                   style="width: 49%;"> <img alt="蚂蚁"
                                                                                                             src="@/assets/img/resources/uploads/3-11.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-10.jpg"> <img alt="蚂蚁"
                                                                                                      src="@/assets/img/resources/uploads/3-11.jpg">
                  <p>弓背蚁可长达3.4-13毫米，多呈黑色，也有一些种类略呈红色和黄色。弓背蚁的工蚁有较大的下颚，其胸腔平滑，呈浑圆形状，腹柄处有明显单节。下颚有5-8颗牙齿。<br>
                    弓背蚁必须有恒定的水源才能生存，喜欢湿度较高的地方通常将巢筑在潮湿的木头里面。筑巢时他们会把木屑掏出来以作通道，这也是为何它们也被称为木匠蚁。横梁、地板或墙壁中都有可能筑巢。但它们不以木材为食，反而偏爱像树蜜以及蚜虫等昆虫分泌物的糖类液体，也以昆虫尸体及血液为食。家中如有弓背蚁筑巢，可能还能听到它们活动时的“沙沙声”。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 6" id="main-body6">
      <div id="detail_div_hidePestDetail_4" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_3" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_5" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="null" alt="" style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">猫蚤</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p></p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><!----> <!----></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div> <!----> <!----> <p></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 7" id="main-body7">
      <div id="detail_div_hidePestDetail_6" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_4" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_7" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/01-1.jpg" alt="苍蝇"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">家蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>无</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Musca domestica/Housefly</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="苍蝇"
                                                                                   src="@/assets/img/resources/uploads/03-1.jpg"
                                                                                   style="width: 49%;"> <img alt="苍蝇"
                                                                                                             src="@/assets/img/resources/uploads/02-4.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/03-1.jpg"> <img alt="苍蝇"
                                                                                                      src="@/assets/img/resources/uploads/02-4.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/01-2.jpg" alt="苍蝇"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">市蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>狗屎苍蝇、叮眼苍蝇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Musca sorbens/Dog dung fly/eye-seeking fly</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      市蝇比家蝇体形稍小，体色稍淡，体长约5-6mm。其复眼无毛，中胸盾片有2条黑色纵条，前胸侧板中央凹陷处无纤毛、腋瓣上肋无前后钢毛簇，第一腹板无纤毛，下侧片在后气门前下方有纤毛，且较家蝇发达。<br>
                      市蝇的食性非常复杂，是属于杂食性蝇类，可以取食各种物质，人的食物、人和畜禽的分泌物和排泄物、厨房残渣等。尤其喜欢在粪便里进行产卵繁殖，是沙眼病的主要传播者，严重的可导致人失明。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="苍蝇"
                                                                                   src="@/assets/img/resources/uploads/03-3.jpg"
                                                                                   style="width: 49%;"> <img alt="苍蝇"
                                                                                                             src="@/assets/img/resources/uploads/02-1.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/03-3.jpg"> <img alt="苍蝇"
                                                                                                      src="@/assets/img/resources/uploads/02-1.jpg">
                  <p>市蝇比家蝇体形稍小，体色稍淡，体长约5-6mm。其复眼无毛，中胸盾片有2条黑色纵条，前胸侧板中央凹陷处无纤毛、腋瓣上肋无前后钢毛簇，第一腹板无纤毛，下侧片在后气门前下方有纤毛，且较家蝇发达。<br>
                    市蝇的食性非常复杂，是属于杂食性蝇类，可以取食各种物质，人的食物、人和畜禽的分泌物和排泄物、厨房残渣等。尤其喜欢在粪便里进行产卵繁殖，是沙眼病的主要传播者，严重的可导致人失明。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/01-3.jpg" alt="苍蝇"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">丽蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>绿头苍蝇、绿豆蝇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Calliphoridae/Blow flies</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目丽蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      丽蝇成虫的外表有光泽的金属色，一般都是蓝色、绿色或黑色。触角分三节及有芒，整条触角芒都呈羽毛状，第二节的触角上有明显的凹陷位。丽蝇副基节上有刚毛，特别是在侧至前接缝有两条背侧刚毛及最后的肩后刚毛。胸部背上有连续的接缝。<br>
                      大部分丽蝇都是吸血生殖且可以反复生殖，一生约产2000颗卵。幼虫共有三个发育阶段，幼虫会分泌蛋白水解酶来消化家畜或尸体的蛋白质，吃腐肉及粪便，肉中的蛆很大部分都是它们。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="苍蝇"
                                                                                   src="@/assets/img/resources/uploads/03-4.jpg"
                                                                                   style="width: 49%;"> <img alt="苍蝇"
                                                                                                             src="@/assets/img/resources/uploads/02-2.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/03-4.jpg"> <img alt="苍蝇"
                                                                                                      src="@/assets/img/resources/uploads/02-2.jpg">
                  <p>
                    丽蝇成虫的外表有光泽的金属色，一般都是蓝色、绿色或黑色。触角分三节及有芒，整条触角芒都呈羽毛状，第二节的触角上有明显的凹陷位。丽蝇副基节上有刚毛，特别是在侧至前接缝有两条背侧刚毛及最后的肩后刚毛。胸部背上有连续的接缝。<br>
                    大部分丽蝇都是吸血生殖且可以反复生殖，一生约产2000颗卵。幼虫共有三个发育阶段，幼虫会分泌蛋白水解酶来消化家畜或尸体的蛋白质，吃腐肉及粪便，肉中的蛆很大部分都是它们。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/01-4.jpg" alt="苍蝇"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">麻蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>肉蝇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Sarcophagidae/Flesh fly</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目麻蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">麻蝇看起来像家蝇，但通常体型较大。它们是灰色的，腹部上方有棋盘格图案，胸部表面有三条黑色条纹，有时在腹部末端有一条红褐色的尖端。<br>
                      麻蝇以卵胎生的方式繁殖，大部分种类的麻蝇都在腐肉、粪便或者腐败的物质上产下蛆，少数种类会在哺乳动物的伤口上产蛆。麻蝇幼虫会从伤口钻到家畜的健康肉中，食用被蝇蛆肉污染的食物会引起肠道感染。成蝇作为病媒很少出现问题，对人类或牲畜健康的威胁很小，不咬人但令人讨厌。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="苍蝇"
                                                                                   src="@/assets/img/resources/uploads/02-3.jpg"
                                                                                   style="width: 49%;"> <img alt="苍蝇"
                                                                                                             src="@/assets/img/resources/uploads/03-5.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/02-3.jpg"> <img alt="苍蝇"
                                                                                                      src="@/assets/img/resources/uploads/03-5.jpg">
                  <p>麻蝇看起来像家蝇，但通常体型较大。它们是灰色的，腹部上方有棋盘格图案，胸部表面有三条黑色条纹，有时在腹部末端有一条红褐色的尖端。<br>
                    麻蝇以卵胎生的方式繁殖，大部分种类的麻蝇都在腐肉、粪便或者腐败的物质上产下蛆，少数种类会在哺乳动物的伤口上产蛆。麻蝇幼虫会从伤口钻到家畜的健康肉中，食用被蝇蛆肉污染的食物会引起肠道感染。成蝇作为病媒很少出现问题，对人类或牲畜健康的威胁很小，不咬人但令人讨厌。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$route.params.id == 8" id="main-body8">
      <div id="detail_div_hidePestDetail_8" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_6" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_9" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-14.jpg" alt="蚊子"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">伊蚊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>老虎蚊子、花斑蚊、花脚蚊</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Aedes</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚊科伊蚊属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚊子"
                                                                                   src="@/assets/img/resources/uploads/2-12.jpg"
                                                                                   style="width: 49%;"> <img alt="蚊子"
                                                                                                             src="@/assets/img/resources/uploads/3-13.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-12.jpg"> <img alt="蚊子"
                                                                                                      src="@/assets/img/resources/uploads/3-13.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-15.jpg" alt="蚊子"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">按蚊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>疟蚊</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Anopheles</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚊科按蚊属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      按蚊成蚊翅上有深色、浅色斑点，身体大多是灰色的，静止时与物体表面呈45度角。幼虫喜在有水草、阳光照射的天然清水中孳生，静止时与水面平行，卵长约1毫米，两侧有助浮物。<br>
                      按蚊孳生于干净无污染的水域，喜欢较深的颜色，大多在夜间活动、取食。大多数分布在热带地区，最主要的分布区是在附属于撒哈拉沙漠的非洲地区。按蚊能传播疟疾，2015年根据WTO世界卫生组织的数据，主要因为蚊子感染的2亿1400多万疟疾病例，一共导致438,000人死亡。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚊子"
                                                                                   src="@/assets/img/resources/uploads/2-13.jpg"
                                                                                   style="width: 49%;"> <img alt="蚊子"
                                                                                                             src="@/assets/img/resources/uploads/3-14.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-13.jpg"> <img alt="蚊子"
                                                                                                      src="@/assets/img/resources/uploads/3-14.jpg">
                  <p>按蚊成蚊翅上有深色、浅色斑点，身体大多是灰色的，静止时与物体表面呈45度角。幼虫喜在有水草、阳光照射的天然清水中孳生，静止时与水面平行，卵长约1毫米，两侧有助浮物。<br>
                    按蚊孳生于干净无污染的水域，喜欢较深的颜色，大多在夜间活动、取食。大多数分布在热带地区，最主要的分布区是在附属于撒哈拉沙漠的非洲地区。按蚊能传播疟疾，2015年根据WTO世界卫生组织的数据，主要因为蚊子感染的2亿1400多万疟疾病例，一共导致438,000人死亡。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-16.jpg" alt="蚊子"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">库蚊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>家蚊</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Culex</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蚊科库蚊属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">成年库蚊可以长达4-10毫米。头部，胸部和腹部界限明确。成虫翼部水平展开而且透明，两个前翼在休息时水平地保持在腹部上方,
                      翼部与足部不带斑点或条纹。 <br>
                      在幼虫阶段，库蚊生活在水中，以有机物颗粒，微生物或植物为食。&nbsp;经过几个小时后，它会变成蛹。与幼虫不同的是，蛹呈逗号形状。它不会吃东西，但可以通过快速抽搐而游动，以避免潜在的捕食者。库蚊可传播西尼罗河病毒，日本脑炎，圣路易斯脑炎或西部和东部马脑炎，且叮咬使人不适且可能引发过敏。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蚊子"
                                                                                   src="@/assets/img/resources/uploads/3-15.jpg"
                                                                                   style="width: 49%;"> <img alt="蚊子"
                                                                                                             src="@/assets/img/resources/uploads/2-14.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/3-15.jpg"> <img alt="蚊子"
                                                                                                      src="@/assets/img/resources/uploads/2-14.jpg">
                  <p>成年库蚊可以长达4-10毫米。头部，胸部和腹部界限明确。成虫翼部水平展开而且透明，两个前翼在休息时水平地保持在腹部上方, 翼部与足部不带斑点或条纹。 <br>
                    在幼虫阶段，库蚊生活在水中，以有机物颗粒，微生物或植物为食。&nbsp;经过几个小时后，它会变成蛹。与幼虫不同的是，蛹呈逗号形状。它不会吃东西，但可以通过快速抽搐而游动，以避免潜在的捕食者。库蚊可传播西尼罗河病毒，日本脑炎，圣路易斯脑炎或西部和东部马脑炎，且叮咬使人不适且可能引发过敏。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 9" id="main-body9">
      <div id="detail_div_hidePestDetail_10" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_7" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_11" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="null" alt="" style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">温带臭虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p></p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><!----> <!----></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div> <!----> <!----> <p></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 10" id="main-body10">
      <div id="detail_div_hidePestDetail_12" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_8" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_13" cclass="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-22.jpg" alt="寄螨"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蜱</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>壁虱、扁虱、草爬子、八脚虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Ixodoidea/Tick</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>寄螨目蜱总科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="寄螨"
                                                                                   src="@/assets/img/resources/uploads/2-19.jpg"
                                                                                   style="width: 49%;"> <img alt="寄螨"
                                                                                                             src="@/assets/img/resources/uploads/3-20.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-19.jpg"> <img alt="寄螨"
                                                                                                      src="@/assets/img/resources/uploads/3-20.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-23.jpg" alt="寄螨"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">革螨</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>虫穴蚲、鸟螨</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Mesostigmata/Bird mite</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>寄螨目革螨总科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      革螨成虫呈卵圆形，黄色或褐色，膜质，具骨化的骨板。长0.2~0.5mm，个别种类可达1.5~3.0mm。虫体分颚体和躯体两部分，颚体位于躯体前方，由颚基、螯肢及须肢组成。<br>
                      寄生型革螨，多数寄生于宿主的体表，少数寄生于体内，如鼻腔、呼吸道、外耳道、肺部等。寄生性革螨以刺吸宿主的血液和组织液为食。大多数革螨整年活动，但有明显的繁殖高峰，一般密度在9月以后逐渐增高，10－11月可出现高峰。革螨叮咬伴有剧痒，常因搔抓引起继发感染。此外革螨可通过刺螫传播病毒。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="寄螨"
                                                                                   src="@/assets/img/resources/uploads/2-20.jpg"
                                                                                   style="width: 49%;"> <img alt="寄螨"
                                                                                                             src="@/assets/img/resources/uploads/3-21.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-20.jpg"> <img alt="寄螨"
                                                                                                      src="@/assets/img/resources/uploads/3-21.jpg">
                  <p>革螨成虫呈卵圆形，黄色或褐色，膜质，具骨化的骨板。长0.2~0.5mm，个别种类可达1.5~3.0mm。虫体分颚体和躯体两部分，颚体位于躯体前方，由颚基、螯肢及须肢组成。<br>
                    寄生型革螨，多数寄生于宿主的体表，少数寄生于体内，如鼻腔、呼吸道、外耳道、肺部等。寄生性革螨以刺吸宿主的血液和组织液为食。大多数革螨整年活动，但有明显的繁殖高峰，一般密度在9月以后逐渐增高，10－11月可出现高峰。革螨叮咬伴有剧痒，常因搔抓引起继发感染。此外革螨可通过刺螫传播病毒。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 11" id="main-body11">
      <div id="detail_div_hidePestDetail_14" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_9" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_15" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="null" alt="" style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">毛衣鱼</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p></p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><!----> <!----></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div> <!----> <!----> <p></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 12" id="main-body12">
      <div id="detail_div_hidePestDetail_16" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_10" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_17" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/0.jpg" alt="厨卫飞虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蛾蚋</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>蛾蠓、蛾蝇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Psychodidae/Drain fly/Sewer gnat</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目蛾蚋科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="厨卫飞虫"
                                                                                   src="@/assets/img/resources/uploads/1-44.jpg"
                                                                                   style="width: 49%;"> <img alt="厨卫飞虫"
                                                                                                             src="@/assets/img/resources/uploads/2-40.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/1-44.jpg"> <img alt="厨卫飞虫"
                                                                                                      src="@/assets/img/resources/uploads/2-40.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/0-1.jpg" alt="厨卫飞虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">果蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>醋蝇、小蝇子</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Drosophila/Fruit flies</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目果蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">果蝇体型较小，长3-4mm，触角呈树枝状。胸部上方黑色，下方灰色，整体看起来是棕褐色，具有硕大的红色复眼。<br>
                      果蝇以成熟或腐烂的水果为生。他们还享受啤酒、白酒和葡萄酒等发酵食品。果蝇在排水沟，垃圾处理，垃圾桶和拖把桶中繁殖和发展，一旦它们开始在室内繁殖，雌性能够产下大约500个卵，并且能在24-30小时内孵化，比较难以控制。在果蝇中，地中海实蝇最为常见，现分布世界80多个国家和地区，能危害250种植物，如柑橘、苹果、梨等水果，被称为“水果头号杀手”。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="厨卫飞虫"
                                                                                   src="@/assets/img/resources/uploads/1-45.jpg"
                                                                                   style="width: 49%;"> <img alt="厨卫飞虫"
                                                                                                             src="@/assets/img/resources/uploads/2-41.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/1-45.jpg"> <img alt="厨卫飞虫"
                                                                                                      src="@/assets/img/resources/uploads/2-41.jpg">
                  <p>果蝇体型较小，长3-4mm，触角呈树枝状。胸部上方黑色，下方灰色，整体看起来是棕褐色，具有硕大的红色复眼。<br>
                    果蝇以成熟或腐烂的水果为生。他们还享受啤酒、白酒和葡萄酒等发酵食品。果蝇在排水沟，垃圾处理，垃圾桶和拖把桶中繁殖和发展，一旦它们开始在室内繁殖，雌性能够产下大约500个卵，并且能在24-30小时内孵化，比较难以控制。在果蝇中，地中海实蝇最为常见，现分布世界80多个国家和地区，能危害250种植物，如柑橘、苹果、梨等水果，被称为“水果头号杀手”。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/0-2.jpg" alt="厨卫飞虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蚤蝇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>驼背蝇、棺蝇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Phoridae/Hump-backed fly</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目蚤蝇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">蚤蝇体型微小，长度0.5-5.5毫米，大多数是黑色或暗褐色。蚤蝇的弓形胸部给他们带来了驼背的外观，所以通常被称为“驼背蝇”。<br>
                      蚤蝇在管道深处繁殖，这使得它们很难在没有帮助的情况下从家中移除。它们喜欢吃在排水沟或其他管道中聚集的潮湿的有机物质、土豆、洋葱、菌类植物和昆虫。还喜欢腐烂的肉体，蚤蝇能在棺材中以群体生活。虽然不会造成直接损害，但它们是干霉菌的有效载体，可能会因此而污染食物。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="厨卫飞虫"
                                                                                   src="@/assets/img/resources/uploads/1-46.jpg"
                                                                                   style="width: 49%;"> <img alt="厨卫飞虫"
                                                                                                             src="@/assets/img/resources/uploads/2-42.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/1-46.jpg"> <img alt="厨卫飞虫"
                                                                                                      src="@/assets/img/resources/uploads/2-42.jpg">
                  <p>蚤蝇体型微小，长度0.5-5.5毫米，大多数是黑色或暗褐色。蚤蝇的弓形胸部给他们带来了驼背的外观，所以通常被称为“驼背蝇”。<br>
                    蚤蝇在管道深处繁殖，这使得它们很难在没有帮助的情况下从家中移除。它们喜欢吃在排水沟或其他管道中聚集的潮湿的有机物质、土豆、洋葱、菌类植物和昆虫。还喜欢腐烂的肉体，蚤蝇能在棺材中以群体生活。虽然不会造成直接损害，但它们是干霉菌的有效载体，可能会因此而污染食物。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/0-3.jpg" alt="厨卫飞虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蕈蚊</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>菌蚊、真菌蚋、真菌蚊、小黑飞</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Sciaroidea/Fungus gnat</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>双翅目蕈蚊科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">蕈蚊体型很小，体长4.5mm左右，翅长约8mm。成虫呈黑色或棕色，有一对精致，清晰的翅膀。成虫经常与蚊子混淆，因为它们细长的悬垂腿。<br>
                      蕈蚊幼虫主要以土壤中的真菌和有机物为食，有时还以花卉作物的根为食，蕈蚊严重侵袭时会导致植物枯萎，失去活力，并使叶子掉落。成虫雌性会叮人。尽管蕈蚊的飞行能力很弱，但成虫会被光线所吸引，从盆栽植物中出来后，可能会聚集在窗户上。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="厨卫飞虫"
                                                                                   src="@/assets/img/resources/uploads/1-47.jpg"
                                                                                   style="width: 49%;"> <img alt="厨卫飞虫"
                                                                                                             src="@/assets/img/resources/uploads/2-43.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/1-47.jpg"> <img alt="厨卫飞虫"
                                                                                                      src="@/assets/img/resources/uploads/2-43.jpg">
                  <p>蕈蚊体型很小，体长4.5mm左右，翅长约8mm。成虫呈黑色或棕色，有一对精致，清晰的翅膀。成虫经常与蚊子混淆，因为它们细长的悬垂腿。<br>
                    蕈蚊幼虫主要以土壤中的真菌和有机物为食，有时还以花卉作物的根为食，蕈蚊严重侵袭时会导致植物枯萎，失去活力，并使叶子掉落。成虫雌性会叮人。尽管蕈蚊的飞行能力很弱，但成虫会被光线所吸引，从盆栽植物中出来后，可能会聚集在窗户上。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 13" id="main-body13">
      <div id="detail_div_hidePestDetail_18" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_11" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_19" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-49.jpg" alt="织物害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">衣蛾</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>袋衣蛾</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Tinea pellionella/Case-bearing clothes moth</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蕈蛾科衣蛾属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      衣蛾幼虫是一个小型的毛毛虫，藏在一个丝质的纺锤形袋状物内，黏在墙壁上。衣蛾成虫翼展为9至16毫米，前翅呈褐色，有一个大斑点和一些较小的模糊黑点。后翅是毛茸茸的浅棕灰色。<br>
                      衣蛾幼虫行动缓慢，一般在丝绸内化蛹，主要食用纤维角蛋白，包括地毯和羊毛等，成虫成虫不进食，唯一的使命就是交配和产卵。多藏匿于衣服存储室，软垫家具缝里，特别喜爱沾有食物或其它污染物的纺织品，长久不穿的衣物衣领等折叠处也容易见其踪迹。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="织物害虫"
                                                                                   src="@/assets/img/resources/uploads/2-45.jpg"
                                                                                   style="width: 49%;"> <img alt="织物害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-41.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-45.jpg">
                  <img alt="织物害虫"
                       src="@/assets/img/resources/uploads/3-41.jpg">
                  <p>衣蛾幼虫是一个小型的毛毛虫，藏在一个丝质的纺锤形袋状物内，黏在墙壁上。衣蛾成虫翼展为9至16毫米，前翅呈褐色，有一个大斑点和一些较小的模糊黑点。后翅是毛茸茸的浅棕灰色。<br>
                    衣蛾幼虫行动缓慢，一般在丝绸内化蛹，主要食用纤维角蛋白，包括地毯和羊毛等，成虫成虫不进食，唯一的使命就是交配和产卵。多藏匿于衣服存储室，软垫家具缝里，特别喜爱沾有食物或其它污染物的纺织品，长久不穿的衣物衣领等折叠处也容易见其踪迹。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-50.jpg" alt="织物害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">小圆皮蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>标本鲣节虫，姬圆皮蠹</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Anthrenus verbasci/Varied carpet beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目皮蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      成虫体长2-3mm，不同色鳞片形成多样的色斑（无红色的中轴线）。体鳞片长条形，长大于宽的2倍。鞘翅上有3条由黄色及白色鳞片构成的波状横带。幼虫长度可达约3.5mm，呈纺锤形，头部圆形，淡黑褐色，向前密生黑色粗毛。<br>
                      幼虫在春季和初夏孵化，成虫在5月下旬至8月上旬之间出现，有访花习性。成虫野外取食花蜜、花粉后，逐渐转向室内外毛发纺织物、皮革制品等上面产卵危害。雌虫平均产卵50粒。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="织物害虫"
                                                                                   src="@/assets/img/resources/uploads/2-46.jpg"
                                                                                   style="width: 49%;"> <img alt="织物害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-42.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-46.jpg"> <img alt="织物害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-42.jpg">
                  <p>
                    成虫体长2-3mm，不同色鳞片形成多样的色斑（无红色的中轴线）。体鳞片长条形，长大于宽的2倍。鞘翅上有3条由黄色及白色鳞片构成的波状横带。幼虫长度可达约3.5mm，呈纺锤形，头部圆形，淡黑褐色，向前密生黑色粗毛。<br>
                    幼虫在春季和初夏孵化，成虫在5月下旬至8月上旬之间出现，有访花习性。成虫野外取食花蜜、花粉后，逐渐转向室内外毛发纺织物、皮革制品等上面产卵危害。雌虫平均产卵50粒。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-51.jpg" alt="织物害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黑皮蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>毛毡黑皮蠹、黑鲣节虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Attagenus unicolor/ Black carpet beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目皮蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      黑皮蠹成虫体长2.8-6mm，宽1.5-2.8mm。呈椭圆形，黑褐色，腿为棕色，触须较短。全体密生褐色至黑色细毛。头部扁圆形，口器赤褐色。幼虫老熟时体节间乳白色，密生黑褐色毛。<br>
                      黑皮蠹成虫喜欢在粮谷中栖息，但不取食粮食，常飞到野外食花蜜或花粉、菌类。有趋光性，能飞善爬，白天多在仓外向阳处或仓库内光亮的地方活动、交配。幼虫才造成实质性危害，抗寒耐饥能力强，喜欢潮湿环境，蛹常夹杂在粮食中。幼虫大肆蚕食源于动物产品的角蛋白，其中包括羊毛、丝绸、兽皮以及毛皮等。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="织物害虫"
                                                                                   src="@/assets/img/resources/uploads/2-47.jpg"
                                                                                   style="width: 49%;"> <img alt="织物害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-43.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-47.jpg"> <img alt="织物害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-43.jpg">
                  <p>黑皮蠹成虫体长2.8-6mm，宽1.5-2.8mm。呈椭圆形，黑褐色，腿为棕色，触须较短。全体密生褐色至黑色细毛。头部扁圆形，口器赤褐色。幼虫老熟时体节间乳白色，密生黑褐色毛。<br>
                    黑皮蠹成虫喜欢在粮谷中栖息，但不取食粮食，常飞到野外食花蜜或花粉、菌类。有趋光性，能飞善爬，白天多在仓外向阳处或仓库内光亮的地方活动、交配。幼虫才造成实质性危害，抗寒耐饥能力强，喜欢潮湿环境，蛹常夹杂在粮食中。幼虫大肆蚕食源于动物产品的角蛋白，其中包括羊毛、丝绸、兽皮以及毛皮等。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-52.jpg" alt="织物害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">花斑皮蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>仓库甲虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Trogoderma variabile/Warehouse beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目皮蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      花斑皮蠹成虫体长2.4-4mm，宽1.2-1.8mm，椭圆形，呈棕色或棕黑色，翼盖上有黄色、白色和棕色的图案，常发现于纺织品和谷物之中。幼虫体长6-7mm，纺锤形，黄褐色，节间淡黄色，生有稀疏的褐色粗短毛，尾端有一束较长褐色毛。<br>
                      花斑皮蠹是杂食性害虫，生活力极强，可耐饥寒，食物缺乏时可忍饥数月，甚至达数年。幼虫在仓库中的缝隙或粮食碎屑中越冬，欢黑暗潮湿。花斑皮蠹的幼虫从谷物、宠物食品到纺织品都可能造成破坏。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="织物害虫"
                                                                                   src="@/assets/img/resources/uploads/2-48.jpg"
                                                                                   style="width: 49%;"> <img alt="织物害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-44.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-48.jpg"> <img alt="织物害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-44.jpg">
                  <p>
                    花斑皮蠹成虫体长2.4-4mm，宽1.2-1.8mm，椭圆形，呈棕色或棕黑色，翼盖上有黄色、白色和棕色的图案，常发现于纺织品和谷物之中。幼虫体长6-7mm，纺锤形，黄褐色，节间淡黄色，生有稀疏的褐色粗短毛，尾端有一束较长褐色毛。<br>
                    花斑皮蠹是杂食性害虫，生活力极强，可耐饥寒，食物缺乏时可忍饥数月，甚至达数年。幼虫在仓库中的缝隙或粮食碎屑中越冬，欢黑暗潮湿。花斑皮蠹的幼虫从谷物、宠物食品到纺织品都可能造成破坏。</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 14" id="main-body14">
      <div id="detail_div_hidePestDetail_20" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_12" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_21" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-54.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">小蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>树皮甲虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Scolytidae/Bark beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目小蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-49.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-46.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-49.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-46.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-56.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">粉蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>粉蛀虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Lyctinae/Powderpost beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目粉蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      粉蠹成虫长度在1-8mm，细长而扁，多呈黄、褐与黑色，表面光滑并生细毛。幼虫颜色较浅，呈乳白色，形状为蛴螬型，常弯勾成C字形。幼虫发育时间可长达2年。<br>
                      粉蠹会通过受其入侵的木材进入住户家中。成年粉蠹也可以直接飞入房屋，将卵产在门框、地板等木材中。粉蠹喜欢在通风不良的地方侵蚀潮湿的木材。在水管空隙或地下室中发现粉蠹，大概率该住宅存在漏水或其他潮湿问题。发现木材表面存在明显的圆洞，圆洞周围有少量木屑，很有可能有粉蠹出现。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-50.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-47.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-50.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-47.jpg">
                  <p>粉蠹成虫长度在1-8mm，细长而扁，多呈黄、褐与黑色，表面光滑并生细毛。幼虫颜色较浅，呈乳白色，形状为蛴螬型，常弯勾成C字形。幼虫发育时间可长达2年。<br>
                    粉蠹会通过受其入侵的木材进入住户家中。成年粉蠹也可以直接飞入房屋，将卵产在门框、地板等木材中。粉蠹喜欢在通风不良的地方侵蚀潮湿的木材。在水管空隙或地下室中发现粉蠹，大概率该住宅存在漏水或其他潮湿问题。发现木材表面存在明显的圆洞，圆洞周围有少量木屑，很有可能有粉蠹出现。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-55.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">窃蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>家具甲虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Anobiidae/Common furniture beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目窃蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">窃蠹成虫体长在1-9mm之间，呈长椭圆形，多为红褐色。窃蠹的身体前部有个类似僧侣的蒙头斗篷的前胸，口器为下口式，俯看时看不到头。<br>
                      窃蠹幼虫会进入木材深处，留下木屑，当它们成年后钻出从木材里出去的通道。他们吃硬木和软木，他们会入侵家具以及框架，地板和其他物品。成虫羽化以后以爬行为主，很少飞翔，有趋暗性。窃蠧的耐寒力较耐热力强，即忍受低温强度和持续时间的能力相对较强。窃蠹留下的孔洞比粉蠹大，大小约3mm。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-51.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-48.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-51.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-48.jpg">
                  <p>窃蠹成虫体长在1-9mm之间，呈长椭圆形，多为红褐色。窃蠹的身体前部有个类似僧侣的蒙头斗篷的前胸，口器为下口式，俯看时看不到头。<br>
                    窃蠹幼虫会进入木材深处，留下木屑，当它们成年后钻出从木材里出去的通道。他们吃硬木和软木，他们会入侵家具以及框架，地板和其他物品。成虫羽化以后以爬行为主，很少飞翔，有趋暗性。窃蠧的耐寒力较耐热力强，即忍受低温强度和持续时间的能力相对较强。窃蠹留下的孔洞比粉蠹大，大小约3mm。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-57.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">天牛</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>啮桑、牛角虫、锯树郎</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Cerambycidae/Longhorn beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目天牛科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      天牛成虫呈长圆筒形，触角着生在前额突起（触角基瘤）上，能自由转动和向后覆盖于虫体背部。除锯天牛类外，中胸背板具发音器。成虫体长通常在1.4-5cm之间，外壳常呈黑色且有白色斑点覆盖，触角也为黑白色。天牛幼虫淡黄或白色，粗肥。<br>
                      天牛卵孵化出幼虫后，初龄幼虫即蛀入树干，最初在树皮下取食，待龄期增大后钻入木质部。幼虫在树干或枝条上蛀食，在一定距离内向树皮上开口作为通气孔，向外推出排泄物和木屑。天牛造成的孔洞比较大，直径可以超过1cm。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-52.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-49.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-52.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-49.jpg">
                  <p>
                    天牛成虫呈长圆筒形，触角着生在前额突起（触角基瘤）上，能自由转动和向后覆盖于虫体背部。除锯天牛类外，中胸背板具发音器。成虫体长通常在1.4-5cm之间，外壳常呈黑色且有白色斑点覆盖，触角也为黑白色。天牛幼虫淡黄或白色，粗肥。<br>
                    天牛卵孵化出幼虫后，初龄幼虫即蛀入树干，最初在树皮下取食，待龄期增大后钻入木质部。幼虫在树干或枝条上蛀食，在一定距离内向树皮上开口作为通气孔，向外推出排泄物和木屑。天牛造成的孔洞比较大，直径可以超过1cm。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-58.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">木蜂</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>钻木蜂</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Xylocopa/Carpenter bee</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>膜翅目木蜂科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      木蜂长约12-25毫米，体粗壮，呈黑绿色或金属蓝色，部背面通常光滑，触角膝状，单眼排成三角形。腿部及胸部有黄色的毛，而腹部顶部则没有明显的毛，无翅痣。<br>
                      木蜂善挖掘木材，会在竹子或其他硬质植物材料（如花梗，通常是死的）中筑巢。筑出的每个巢穴都有一个入口，可能有许多相邻的隧道。木蜂不食用木头，它们会将剩余的木材丢弃或用作蜂房分区的材料，其留下的孔洞直径大小约在16mm。雌性木蜂可能会叮咬人。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-53.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-50.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-53.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-50.jpg">
                  <p>木蜂长约12-25毫米，体粗壮，呈黑绿色或金属蓝色，部背面通常光滑，触角膝状，单眼排成三角形。腿部及胸部有黄色的毛，而腹部顶部则没有明显的毛，无翅痣。<br>
                    木蜂善挖掘木材，会在竹子或其他硬质植物材料（如花梗，通常是死的）中筑巢。筑出的每个巢穴都有一个入口，可能有许多相邻的隧道。木蜂不食用木头，它们会将剩余的木材丢弃或用作蜂房分区的材料，其留下的孔洞直径大小约在16mm。雌性木蜂可能会叮咬人。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-59.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">竹蠹</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>竹长蠹</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Dinoderus minutus/Bamboo borer</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目长蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      竹蠹成虫体长约2.6-3.5mm，呈粗短圆筒形，多为暗赤褐色至黑褐色，有光泽。竹蠹头部额区有密而明显的刻点，前胸背板靠后中央有一对并列的凹陷。<br>
                      竹蠹一般以幼虫或成虫越冬，也发现过以蛹越冬的情况。越冬成虫在三四月份开始活动并交配产卵。成虫喜隐藏在缝隙内或阴暗处。幼虫会对竹子等植物及部分食物造成危害：它们会在木薯、薯干及其它食物缝隙内或咬破竹器边缘产卵。幼虫孵化后直接钻入食物内部形成蛀洞。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-55.jpg"
                                                                                   style="width: 49%;"> <img alt="蛀木害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-51.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-55.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-51.jpg">
                  <p>竹蠹成虫体长约2.6-3.5mm，呈粗短圆筒形，多为暗赤褐色至黑褐色，有光泽。竹蠹头部额区有密而明显的刻点，前胸背板靠后中央有一对并列的凹陷。<br>
                    竹蠹一般以幼虫或成虫越冬，也发现过以蛹越冬的情况。越冬成虫在三四月份开始活动并交配产卵。成虫喜隐藏在缝隙内或阴暗处。幼虫会对竹子等植物及部分食物造成危害：它们会在木薯、薯干及其它食物缝隙内或咬破竹器边缘产卵。幼虫孵化后直接钻入食物内部形成蛀洞。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-60.jpg" alt="蛀木害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黑尾拟天牛</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>码头蛀虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Narcerdes melanura/Wharf borer</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>拟天牛科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">黑尾拟天牛体型狭长，长相酷似天牛。成虫体长约10mm，身体橙色，尾部黑色是其特点。其幼虫生活在潮湿的枯木内。<br>
                      黑尾拟天牛喜欢栖息在潮湿闷热的环境中，常在食品厂、住宅中等地发现其踪迹，雨水浸湿的建筑木材和埋在混凝土地基、道路和步行街下的块状木料也是常见危害地。黑尾拟天牛也会入侵室内，咬噬高档家具，木质地板等，造成的损失不容小觑。此外，黑尾拟天牛能分泌毒液，人被咬后皮肤上会生水泡。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="蛀木害虫"
                                                                                   src="@/assets/img/resources/uploads/2-56.jpg"
                                                                                   style=" width: 49%;"> <img alt="蛀木害虫"
                                                                                                              src="@/assets/img/resources/uploads/3-52.jpg"
                                                                                                              style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-56.jpg"> <img alt="蛀木害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-52.jpg">
                  <p>黑尾拟天牛体型狭长，长相酷似天牛。成虫体长约10mm，身体橙色，尾部黑色是其特点。其幼虫生活在潮湿的枯木内。<br>
                    黑尾拟天牛喜欢栖息在潮湿闷热的环境中，常在食品厂、住宅中等地发现其踪迹，雨水浸湿的建筑木材和埋在混凝土地基、道路和步行街下的块状木料也是常见危害地。黑尾拟天牛也会入侵室内，咬噬高档家具，木质地板等，造成的损失不容小觑。此外，黑尾拟天牛能分泌毒液，人被咬后皮肤上会生水泡。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 15" id="main-body15">
      <div id="detail_div_hidePestDetail_22" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_13" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_23" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-62.jpg" alt="叮蛰害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">寄生蜂</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>姬蜂、小蜂、肿腿蜂</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Parasitoid wasp</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>膜翅目寄生蜂下目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="叮蛰害虫"
                                                                                   src="@/assets/img/resources/uploads/2-58.jpg"
                                                                                   style="width: 49%;"> <img alt="叮蛰害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-54.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-58.jpg"> <img alt="叮蛰害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-54.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-63.jpg" alt="叮蛰害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蜜蜂</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Apis/Honey bee</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>膜翅目蜜蜂科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      蜜蜂体长8—20mm，呈黄褐色或黑褐色，生有密毛；头与胸几乎同样宽；腰部较胸部、腹部纤细；触角膝状，复眼椭圆形，口器嚼吸式，后足为携粉足。两对膜质翅，前翅大，后翅小，腹部近椭圆形，覆有绒毛，腹末有螫针。<br>
                      雄蜂不具有蛰针的蜂种，有良好的飞行能力，这是与蜂王交配成功概率的保证。蜂王为蜜蜂社群的唯一母亲， 一天可产卵1500-
                      2000颗卵。蜜蜂依靠采食蜂蜜为生。蜜蜂蛰刺是一次性的，蜇完后即会死亡。<br>
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="叮蛰害虫"
                                                                                   src="@/assets/img/resources/uploads/2-59.jpg"
                                                                                   style="width: 49%;"> <img alt="叮蛰害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-55.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-59.jpg"> <img alt="叮蛰害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-55.jpg">
                  <p>
                    蜜蜂体长8—20mm，呈黄褐色或黑褐色，生有密毛；头与胸几乎同样宽；腰部较胸部、腹部纤细；触角膝状，复眼椭圆形，口器嚼吸式，后足为携粉足。两对膜质翅，前翅大，后翅小，腹部近椭圆形，覆有绒毛，腹末有螫针。<br>
                    雄蜂不具有蛰针的蜂种，有良好的飞行能力，这是与蜂王交配成功概率的保证。蜂王为蜜蜂社群的唯一母亲， 一天可产卵1500- 2000颗卵。蜜蜂依靠采食蜂蜜为生。蜜蜂蛰刺是一次性的，蜇完后即会死亡。<br>
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-64.jpg" alt="叮蛰害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">黄蜂</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>胡蜂、马蜂</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Wasp</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>膜翅目细腰亚目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      黄蜂其实是一个宽泛的概念，是细腰亚目内除蜜蜂和蚂蚁外所有昆虫的统称，但通常指其中的胡蜂科。黄蜂成虫体多呈鲜艳的黑、黄、棕三色相间，腹部尾端内隐藏了一支退化的输卵管，即有毒蜂针，体长14-18mm。<br>
                      黄蜂的幼虫尾部可附着于巢穴底，即使窝巢是倒吊的也不至于摔落，并且由工蜂负责喂食，从卵到羽化只需要二到三星期的时间。幼虫阶段是以其他小虫为食，尤其是毛毛虫。胡蜂最易怒且最具有攻击性，可对人发动多次袭击或蜇刺人。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="叮蛰害虫"
                                                                                   src="@/assets/img/resources/uploads/2-60.jpg"
                                                                                   style="width: 49%;"> <img alt="叮蛰害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-56.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-60.jpg"> <img alt="叮蛰害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-56.jpg">
                  <p>
                    黄蜂其实是一个宽泛的概念，是细腰亚目内除蜜蜂和蚂蚁外所有昆虫的统称，但通常指其中的胡蜂科。黄蜂成虫体多呈鲜艳的黑、黄、棕三色相间，腹部尾端内隐藏了一支退化的输卵管，即有毒蜂针，体长14-18mm。<br>
                    黄蜂的幼虫尾部可附着于巢穴底，即使窝巢是倒吊的也不至于摔落，并且由工蜂负责喂食，从卵到羽化只需要二到三星期的时间。幼虫阶段是以其他小虫为食，尤其是毛毛虫。胡蜂最易怒且最具有攻击性，可对人发动多次袭击或蜇刺人。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 16" id="main-body16">
      <div id="detail_div_hidePestDetail_24" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_14" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_25" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-66.jpg" alt=""
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">书虱</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>啮虫、米虱</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Psocoptera/Booklice</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>啮虫目虱啮科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/2-62.jpg" style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/3-58.jpg" style="width: 49%;"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-62.jpg"> <img
                  src="@/assets/img/resources/uploads/3-58.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-67.jpg" alt="潮湿害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">跳虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>烟灰虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Poduridae/Springtail</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>弹尾目跳虫科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      跳虫是微小的昆虫，长为0.25至6mm。跳虫腹部下方有弹簧结构，当其受到干扰时，该结构被释放，导致跳虫被抛入空中。一次跳跃可以达到10cm高。<br>
                      跳虫通常栖息在户外，一般栖息在潮湿的土壤中。花坛，原木，铺路石和盆栽中很常见，也会栖息在室内场所，包括浴室、厨房和地下室。跳虫通过身体表面排除水分，如果他们的环境变得干燥，他们会尝试迁移到更潮湿的地方。跳虫以霉菌和真菌为食。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="潮湿害虫"
                                                                                   src="@/assets/img/resources/uploads/2-63.jpg"
                                                                                   style="width: 49%;"> <img alt="潮湿害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-59.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-63.jpg"> <img alt="潮湿害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-59.jpg">
                  <p>跳虫是微小的昆虫，长为0.25至6mm。跳虫腹部下方有弹簧结构，当其受到干扰时，该结构被释放，导致跳虫被抛入空中。一次跳跃可以达到10cm高。<br>
                    跳虫通常栖息在户外，一般栖息在潮湿的土壤中。花坛，原木，铺路石和盆栽中很常见，也会栖息在室内场所，包括浴室、厨房和地下室。跳虫通过身体表面排除水分，如果他们的环境变得干燥，他们会尝试迁移到更潮湿的地方。跳虫以霉菌和真菌为食。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-1.jpeg" alt="潮湿害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">薪甲</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Latridiidae/Minute brown scavenger beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p></p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      薪甲体长1-3mm，呈长形，头突出，触角11节，末端3节膨大成棒状。前胸背板明显窄于鞘翅基部，两侧呈圆形。鞘翅盖及腹端，翅面具粗的刻点行或脊线。足细长，前足基节窝关闭。<br>
                      薪甲成虫和幼虫喜食潮湿的微环境中产生的真菌，主要以丝状真菌的菌丝和孢子为食。薪甲可危害苹果树、梨树或其他果木，成虫的活动性很强，经常以群落形式出现。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="潮湿害虫"
                                                                                   src="@/assets/img/resources/uploads/2-64.jpg"
                                                                                   style="width: 49%;"> <img alt="潮湿害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-60.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-64.jpg"> <img alt="潮湿害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-60.jpg">
                  <p>薪甲体长1-3mm，呈长形，头突出，触角11节，末端3节膨大成棒状。前胸背板明显窄于鞘翅基部，两侧呈圆形。鞘翅盖及腹端，翅面具粗的刻点行或脊线。足细长，前足基节窝关闭。<br>
                    薪甲成虫和幼虫喜食潮湿的微环境中产生的真菌，主要以丝状真菌的菌丝和孢子为食。薪甲可危害苹果树、梨树或其他果木，成虫的活动性很强，经常以群落形式出现。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-68.jpg" alt="潮湿害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">拟裸蛛甲</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Gibbium aequinoctiale/Smooth spider beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目蛛甲科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">拟裸蛛甲体长 2～3mm。呈棕红色，有强光泽，背面强烈隆起呈卵圆形，头小而下垂，额区有 1
                      条纵凹纹，在复眼的上方、下方和后方有多条近平行的脊纹，伸达前胸背板前缘；两触角窝的后缘线在中央会合成直角。前胸背板小，光滑少毛无刻点。<br>
                      拟裸蛛甲喜欢在夜间觅食，因此很少见到。它们也喜欢阴暗潮湿的地方，并且以潮湿霉变的食物为食，可以栖息在墙壁上或阁楼中，在粮仓，面包店等木地板的裂缝中，以及鸟类和啮齿动物的巢穴也有它们的踪迹。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="潮湿害虫"
                                                                                   src="@/assets/img/resources/uploads/2-65.jpg"
                                                                                   style="width: 49%;"> <img alt="潮湿害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-61.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-65.jpg"> <img alt="潮湿害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-61.jpg">
                  <p>拟裸蛛甲体长 2～3mm。呈棕红色，有强光泽，背面强烈隆起呈卵圆形，头小而下垂，额区有 1
                    条纵凹纹，在复眼的上方、下方和后方有多条近平行的脊纹，伸达前胸背板前缘；两触角窝的后缘线在中央会合成直角。前胸背板小，光滑少毛无刻点。<br>
                    拟裸蛛甲喜欢在夜间觅食，因此很少见到。它们也喜欢阴暗潮湿的地方，并且以潮湿霉变的食物为食，可以栖息在墙壁上或阁楼中，在粮仓，面包店等木地板的裂缝中，以及鸟类和啮齿动物的巢穴也有它们的踪迹。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-69.jpg" alt="潮湿害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">米扁虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Ahasverus advena</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目锯谷盗科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">米扁虫颜色为红棕色。成虫长2至3mm。从上方观察时，米扁虫头部后面的外壳在前角上有圆形突起。使用放大镜可以更容易地看到这些特征。<br>
                      米扁虫会入侵谷仓，也能栖息在其他地方，例如潮湿的墙壁、被遗忘的食品包装和潮湿的浴室。多食用死昆虫、真菌和发霉的粮食。米扁虫可以从墙内空隙入侵新房，或从踢脚板和天花板固定装置进入生活空间，窗户也可能是其进入室内的一个途径。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="潮湿害虫"
                                                                                   src="@/assets/img/resources/uploads/2-66.jpg"
                                                                                   style="width: 49%;"> <img alt="潮湿害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-62.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-66.jpg"> <img alt="潮湿害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-62.jpg">
                  <p>米扁虫颜色为红棕色。成虫长2至3mm。从上方观察时，米扁虫头部后面的外壳在前角上有圆形突起。使用放大镜可以更容易地看到这些特征。<br>
                    米扁虫会入侵谷仓，也能栖息在其他地方，例如潮湿的墙壁、被遗忘的食品包装和潮湿的浴室。多食用死昆虫、真菌和发霉的粮食。米扁虫可以从墙内空隙入侵新房，或从踢脚板和天花板固定装置进入生活空间，窗户也可能是其进入室内的一个途径。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-70.jpg" alt="潮湿害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">日本伪瓢虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Endomychidae/Handsome fungus beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目伪瓢虫科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">日本伪瓢虫长1-18mm，成虫呈椭圆至细长椭圆形，并在构造上可呈凸起至稍微扁平状。鞘翅上覆盖刚毛，刚毛通常是直立的。<br>
                      绝大多数的日本伪瓢虫以真菌为食，部分种类也吃木耳，霉菌，孢子，甚至有些有兼性植食性。有几种日本伪瓢虫还被视为仓储害虫。此外，有许多种日本伪瓢虫是社会性昆虫。通常情况下，日本伪瓢虫并不会咬人，但会给人造成烦扰。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="潮湿害虫"
                                                                                   src="@/assets/img/resources/uploads/2-67.jpg"
                                                                                   style="width: 49%;"> <img alt="潮湿害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-63.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-67.jpg"> <img alt="潮湿害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-63.jpg">
                  <p>日本伪瓢虫长1-18mm，成虫呈椭圆至细长椭圆形，并在构造上可呈凸起至稍微扁平状。鞘翅上覆盖刚毛，刚毛通常是直立的。<br>
                    绝大多数的日本伪瓢虫以真菌为食，部分种类也吃木耳，霉菌，孢子，甚至有些有兼性植食性。有几种日本伪瓢虫还被视为仓储害虫。此外，有许多种日本伪瓢虫是社会性昆虫。通常情况下，日本伪瓢虫并不会咬人，但会给人造成烦扰。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 17" id="main-body17">
      <div id="detail_div_hidePestDetail_26" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_15" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_27" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-72.jpg" alt=""
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">锯谷盗</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>麦牛子、麦油子</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Oryzaephilus surinamensis/Sawtoothed grain beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目锯谷盗科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/2-69.jpg" style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/3-65.jpg" style="width: 49%;"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-69.jpg"> <img
                  src="@/assets/img/resources/uploads/3-65.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-73.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">豆象</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>豆象鼻虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Bruchinae/Bean weevil</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目豆象科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      豆象体卵圆，体型中小。复眼大，前缘强烈凹入。触角11节，呈栉齿状。鞘翅覆有白色或棕色毛，常形成斑纹，末端截形。幼虫为复变态，第1龄有长足，胸板有齿，经过一次蜕皮后，足部分或全部消失，形成不甚活泼的蠕虫型幼虫。<br>
                      豆象性活泼，善于飞翔，多以成虫越冬。产卵习性因种而异，除野生外，仓库内的豆象在所寄生的豆上产卵；豌豆象则在仓内越冬，次年春天飞出到大田，在结荚的豌豆上产卵。豆象多为单宿主，即专寄生于某一种豆科植物，少数食性广，危害多种豆类。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-70.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-66.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-70.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-66.jpg">
                  <p>
                    豆象体卵圆，体型中小。复眼大，前缘强烈凹入。触角11节，呈栉齿状。鞘翅覆有白色或棕色毛，常形成斑纹，末端截形。幼虫为复变态，第1龄有长足，胸板有齿，经过一次蜕皮后，足部分或全部消失，形成不甚活泼的蠕虫型幼虫。<br>
                    豆象性活泼，善于飞翔，多以成虫越冬。产卵习性因种而异，除野生外，仓库内的豆象在所寄生的豆上产卵；豌豆象则在仓内越冬，次年春天飞出到大田，在结荚的豌豆上产卵。豆象多为单宿主，即专寄生于某一种豆科植物，少数食性广，危害多种豆类。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-74.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">米象</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>蛘子、牛子（赤峰地区）、蛀牛子（川西北）、米虫、谷牛</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Sitophilus oryzae/Rice weevil</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目象甲科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">成年米象能够飞行，并且可以存活长达两年。雌性每天产2-6个卵，一生产卵多达300个。<br>
                      米象的耐寒力较弱，气温低于15℃，成虫开始冬眠。在 5℃下经过 21
                      天，就开始死亡。在常温下，米象能自身发热，若繁殖数量多，或冬季常温较高的地区，冬季可不潜伏休眠。米象具有群集、喜潮湿、负趋光等特性，繁殖力较强。生活喜高温，最适温度 30-33 ℃。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-71.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-67.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-71.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-67.jpg">
                  <p>成年米象能够飞行，并且可以存活长达两年。雌性每天产2-6个卵，一生产卵多达300个。<br>
                    米象的耐寒力较弱，气温低于15℃，成虫开始冬眠。在 5℃下经过 21
                    天，就开始死亡。在常温下，米象能自身发热，若繁殖数量多，或冬季常温较高的地区，冬季可不潜伏休眠。米象具有群集、喜潮湿、负趋光等特性，繁殖力较强。生活喜高温，最适温度 30-33 ℃。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-75.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">烟草甲</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>烟草窃蠹、烟草标本虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Lasioderma serricorne/Cigarette beetle/Tabacco beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目窃蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      烟草甲成虫身体呈卵圆形，长约3mm，颜色呈红黄色至红褐色。头生在前胸下面，下口式，背面看通常看不到头。前胸背板高凸，圆弧形。复眼大，黑色。触角11节，锯齿状。鞘翅上的刻点不明显，也不排列成纵行。<br>
                      烟草甲是一种世界性的储藏物害虫，食性复杂。在粮食仓库里危害谷物，豆类，油料等粮食；在烟叶仓库里危害储藏的烟叶，香烟和雪茄等烟草制品。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-72.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-68.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-72.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-68.jpg">
                  <p>
                    烟草甲成虫身体呈卵圆形，长约3mm，颜色呈红黄色至红褐色。头生在前胸下面，下口式，背面看通常看不到头。前胸背板高凸，圆弧形。复眼大，黑色。触角11节，锯齿状。鞘翅上的刻点不明显，也不排列成纵行。<br>
                    烟草甲是一种世界性的储藏物害虫，食性复杂。在粮食仓库里危害谷物，豆类，油料等粮食；在烟叶仓库里危害储藏的烟叶，香烟和雪茄等烟草制品。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-76.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">药材甲</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>药谷盗、面包蠹虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Stegobium paniceum/Drugstore beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目窃蠹科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      药材甲身体呈椭圆形，长约3毫米，红褐色至深栗色。头生在前胸下面，下口式，背面看不见头。前胸背板高凸，帽状。复眼大，黑褐色。触角11节，末端3节扁平呈三角形。鞘翅上的刻点明显，并排列成纵行。<br>
                      药材甲倾向于以药理学产品为食。这是因为它偏爱干燥的草药和有时用作药物的植物材料。它还可以食用各种干燥食品和香料，以及头发，皮革，书籍和博物馆标本。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-73.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-69.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-73.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-69.jpg">
                  <p>药材甲身体呈椭圆形，长约3毫米，红褐色至深栗色。头生在前胸下面，下口式，背面看不见头。前胸背板高凸，帽状。复眼大，黑褐色。触角11节，末端3节扁平呈三角形。鞘翅上的刻点明显，并排列成纵行。<br>
                    药材甲倾向于以药理学产品为食。这是因为它偏爱干燥的草药和有时用作药物的植物材料。它还可以食用各种干燥食品和香料，以及头发，皮革，书籍和博物馆标本。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-77.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">赤拟谷盗</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>面粉虫、牛子</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Tribolium castaneum/Red flour beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目拟步甲科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      赤拟谷盗成虫长椭圆形，体长2-4mm，比杂拟谷盗略小些，全身赤褐色至褐色，体上密布小刻点，背面光滑，具光泽，头扁阔；触角锤状11节，锤端3节膨大，鞘翅长达腹末，与前胸背板同宽，上具10条纵刻点行。<br>
                      幼虫细长圆筒形，长6-8mm，有胸足3对，头浅褐色，口器黑褐色，触角3节。胸、腹部12节，各节前半部骨化区浅褐色，后半部黄白色。<br>
                      赤拟谷盗可寄主于食用菌、玉米、小麦、稻、高粱、烟叶等。主要危害面粉，该虫有臭腺分泌臭液，使面粉发生霉腥味，其分泌物还含有致癌物苯醌。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-74.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-70.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-74.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-70.jpg">
                  <p>
                    赤拟谷盗成虫长椭圆形，体长2-4mm，比杂拟谷盗略小些，全身赤褐色至褐色，体上密布小刻点，背面光滑，具光泽，头扁阔；触角锤状11节，锤端3节膨大，鞘翅长达腹末，与前胸背板同宽，上具10条纵刻点行。<br>
                    幼虫细长圆筒形，长6-8mm，有胸足3对，头浅褐色，口器黑褐色，触角3节。胸、腹部12节，各节前半部骨化区浅褐色，后半部黄白色。<br>
                    赤拟谷盗可寄主于食用菌、玉米、小麦、稻、高粱、烟叶等。主要危害面粉，该虫有臭腺分泌臭液，使面粉发生霉腥味，其分泌物还含有致癌物苯醌。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-78.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">杂拟谷盗</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>杂拟谷甲、广颊谷蛀</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Confused flour beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目拟步甲科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      杂拟谷盗成虫与赤拟谷盗极为相似，但体长2.6-5.6mm，比赤拟谷盗略大些。赤拟谷盗触角末端3节庞大，杂拟谷盗后5节则逐渐变大。杂拟谷盗复眼小，间距远（约3个复眼）。<br>
                      杂拟谷盗栖息场地与赤拟谷盗也相似，多以成虫群集越冬，以幼虫越冬者少。成虫喜黑暗，不善飞翔，有群集、假死和分泌臭腺的习性。成虫和幼虫耐饥力均很强，在无食料的条件下雌虫可维持生命18天，雄虫可维持生命~13.6天。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-75.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-71.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-75.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-71.jpg">
                  <p>杂拟谷盗成虫与赤拟谷盗极为相似，但体长2.6-5.6mm，比赤拟谷盗略大些。赤拟谷盗触角末端3节庞大，杂拟谷盗后5节则逐渐变大。杂拟谷盗复眼小，间距远（约3个复眼）。<br>
                    杂拟谷盗栖息场地与赤拟谷盗也相似，多以成虫群集越冬，以幼虫越冬者少。成虫喜黑暗，不善飞翔，有群集、假死和分泌臭腺的习性。成虫和幼虫耐饥力均很强，在无食料的条件下雌虫可维持生命18天，雄虫可维持生命~13.6天。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-79.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">锈赤扁谷盗</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Cryptolestes ferrugineus/Rusty grain beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目扁谷盗科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      赤锈扁谷盗成虫体长1.7～2.34mm，赤褐色，身形扁平，具光泽。头部和前胸背板上的刻点少而稀。雄虫触角长约等于体长的1/2，雌虫触角略短。前胸背板两侧缘向基部方向显著收缩，雄虫更明显，前角略突出。<br>
                      锈赤扁谷盗的最适合发育的温度为32～35℃。它不但可在小麦等食物上产卵发育，也经常发现于树皮下、土壤内或植物性材料的堆放处。除取食植物性物质外，还可兼营捕食性生活，并具有同类相残习性。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-76.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-72.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-76.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-72.jpg">
                  <p>赤锈扁谷盗成虫体长1.7～2.34mm，赤褐色，身形扁平，具光泽。头部和前胸背板上的刻点少而稀。雄虫触角长约等于体长的1/2，雌虫触角略短。前胸背板两侧缘向基部方向显著收缩，雄虫更明显，前角略突出。<br>
                    锈赤扁谷盗的最适合发育的温度为32～35℃。它不但可在小麦等食物上产卵发育，也经常发现于树皮下、土壤内或植物性材料的堆放处。除取食植物性物质外，还可兼营捕食性生活，并具有同类相残习性。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-80.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">印度谷螟</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>印度谷蛾、封顶虫、印度螟蛾</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Plodia interpunctella/Indianmeal moth</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鳞翅目斑螟科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">印度谷螟幼虫体长10～13 mm，体呈圆筒形，中间稍膨大。头部赤褐色。胸腹部淡黄白色，腹部背面带淡粉红色。成虫为小型蛾子。体长5～9
                      mm，翅展13～16 mm。头部灰褐色，腹部灰白色。前翅细长，基半部黄白色，其余部分亮赤褐色，并散生黑色斑纹。后翅灰白色。<br>
                      印度谷螟为喜温暖害虫，生长发育的适宜温度为24～30 ℃，幼虫常吐丝结网封住粮面，或吐丝连缀食物成小团与块状，藏在内面取食。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-77.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-73.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-77.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-73.jpg">
                  <p>印度谷螟幼虫体长10～13 mm，体呈圆筒形，中间稍膨大。头部赤褐色。胸腹部淡黄白色，腹部背面带淡粉红色。成虫为小型蛾子。体长5～9 mm，翅展13～16
                    mm。头部灰褐色，腹部灰白色。前翅细长，基半部黄白色，其余部分亮赤褐色，并散生黑色斑纹。后翅灰白色。<br>
                    印度谷螟为喜温暖害虫，生长发育的适宜温度为24～30 ℃，幼虫常吐丝结网封住粮面，或吐丝连缀食物成小团与块状，藏在内面取食。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-81.jpg" alt="仓储害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">粉斑螟</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>粉斑螟蛾、干果螟</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Ephestia Cautella/Almond moth</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鳞翅目斑螟科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">粉斑螟成虫体长 6~7mm，翅展
                      14~16mm，前翅狭长，淡褐色，有时为灰黑色，近基部1/3处有一不明显的淡色纹横断前翅，纹外翅色较深。后翅灰白色。老熟幼虫体长 12~14mm，头部赤褐色，刚毛基部有较明显的小黑点。<br>
                      常见于进口食品货物中。是储存的谷物、坚果、干果、油籽及油饼等的首要害虫。很少攻击烟草和动物制品。成年蛾不进食。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="仓储害虫"
                                                                                   src="@/assets/img/resources/uploads/2-78.jpg"
                                                                                   style="width: 49%;"> <img alt="仓储害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-74-4.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-78.jpg"> <img alt="仓储害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-74-4.jpg">
                  <p>粉斑螟成虫体长 6~7mm，翅展 14~16mm，前翅狭长，淡褐色，有时为灰黑色，近基部1/3处有一不明显的淡色纹横断前翅，纹外翅色较深。后翅灰白色。老熟幼虫体长
                    12~14mm，头部赤褐色，刚毛基部有较明显的小黑点。<br>
                    常见于进口食品货物中。是储存的谷物、坚果、干果、油籽及油饼等的首要害虫。很少攻击烟草和动物制品。成年蛾不进食。</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 18" id="main-body18">
      <div id="detail_div_hidePestDetail_28" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_16" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_29" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-38.jpg" alt="多足害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">潮虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>地虱婆、地虱子、鼠妇</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Oniscidea/Woodlouse/Sowbug</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>等足目潮虫亚目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="多足害虫"
                                                                                   src="@/assets/img/resources/uploads/2_chaochong.jpg"
                                                                                   style="width: 49%;"> <img alt="多足害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-33.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2_chaochong.jpg"> <img alt="多足害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-33.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1.jpeg" alt="多足害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">鼠妇</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>西瓜虫、负蟠、鼠姑、地虱</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Armadillidiidae/Roly-poly/Pillbug</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>潮虫亚目球鼠妇科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      （球）鼠妇成虫体长8.5～10.5mm，体背灰色或褐色，体宽而扁，稍有光泽，第一胸节与颈愈合；体分13节，第八、第九两个体节明显缢缩，末节呈三角形.（球）鼠妇与潮虫极为相似，但潮虫不能卷曲成球形，（球）鼠妇可以。此外潮虫有两条附肢，看起来如同尾巴，但（球）鼠妇没有。<br>
                      鼠妇通常生活于潮湿、腐殖质丰富的地方，如潮湿处的石块下、腐烂的木料下、树洞中、潮湿的草丛和苔藓丛中、庭院的水缸下、花盆下以至室内的阴湿处。杂食性，食枯叶、枯草、绿色植物、菌孢子等。秋季为鼠妇的繁殖旺盛期。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="多足害虫"
                                                                                   src="@/assets/img/resources/uploads/2-35.jpg"
                                                                                   style="width: 49%;"> <img alt="多足害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-34.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-35.jpg"> <img alt="多足害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-34.jpg">
                  <p>
                    （球）鼠妇成虫体长8.5～10.5mm，体背灰色或褐色，体宽而扁，稍有光泽，第一胸节与颈愈合；体分13节，第八、第九两个体节明显缢缩，末节呈三角形.（球）鼠妇与潮虫极为相似，但潮虫不能卷曲成球形，（球）鼠妇可以。此外潮虫有两条附肢，看起来如同尾巴，但（球）鼠妇没有。<br>
                    鼠妇通常生活于潮湿、腐殖质丰富的地方，如潮湿处的石块下、腐烂的木料下、树洞中、潮湿的草丛和苔藓丛中、庭院的水缸下、花盆下以至室内的阴湿处。杂食性，食枯叶、枯草、绿色植物、菌孢子等。秋季为鼠妇的繁殖旺盛期。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-39.jpg" alt="多足害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蜈蚣</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>天龙、百脚、吴公</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Chilopoda/Centipedes</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>唇足纲蜈蚣目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">蜈蚣蜈蚣呈扁平长条形，长 9～17 厘米，宽 0.5～1 厘米。全体由 22
                      个环节组成，最后一节略细小。脚呈钩状，锐利，钩端有毒腺口，一般称为腭牙、牙爪或毒肢等，能排出毒汁。<br>
                      被蜈蚣咬伤后，其毒腺分泌出大量毒液，顺腭牙的毒腺口注入被咬者皮下而致中毒，毒素不强，被蛰后会造成疼痛但不会致命。蜈蚣惧畏日光，昼伏夜出，喜欢在阴暗、温暖、避雨、空气流通的地方生活。白天多潜伏在砖石缝隙、墙脚边和成堆的树叶、杂草、腐木阴暗角落里，夜间出来活动，寻食青虫、蜘蛛、蟑螂等。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="多足害虫"
                                                                                   src="@/assets/img/resources/uploads/2-36.jpg"
                                                                                   style="width: 49%;"> <img alt="多足害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-35.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-36.jpg"> <img alt="多足害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-35.jpg">
                  <p>蜈蚣蜈蚣呈扁平长条形，长 9～17 厘米，宽 0.5～1 厘米。全体由 22 个环节组成，最后一节略细小。脚呈钩状，锐利，钩端有毒腺口，一般称为腭牙、牙爪或毒肢等，能排出毒汁。<br>
                    被蜈蚣咬伤后，其毒腺分泌出大量毒液，顺腭牙的毒腺口注入被咬者皮下而致中毒，毒素不强，被蛰后会造成疼痛但不会致命。蜈蚣惧畏日光，昼伏夜出，喜欢在阴暗、温暖、避雨、空气流通的地方生活。白天多潜伏在砖石缝隙、墙脚边和成堆的树叶、杂草、腐木阴暗角落里，夜间出来活动，寻食青虫、蜘蛛、蟑螂等。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-40.jpg" alt="多足害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蚰蜒</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>百足虫、小蜈蚣</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Scutigera coleoptrata/House Centipede</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>唇足纲蚰蜒目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      蚰蜒跟蜈蚣相比体短而微扁，棕黄色。体长1.5至5cm。全身分十五节，每节有组长的足一对，最后一对足特长，足易脱落。触角和脚部很细很长,毒颚很大。蚰蜒属于代谢较低、生长缓慢、繁殖能力差而寿命很长的物种。多在夏秋季节活动，爬行速度较快，常栖居房屋内外阴暗潮湿处，爬行于墙壁、蚊帐、家具、床下，以捕捉小昆虫为食。我国常见的为花蚰蜒，或称大蚰蜒。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="多足害虫"
                                                                                   src="@/assets/img/resources/uploads/2-37.jpg"
                                                                                   style="width: 49%;"> <img alt="多足害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-36.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-37.jpg"> <img alt="多足害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-36.jpg">
                  <p>
                    蚰蜒跟蜈蚣相比体短而微扁，棕黄色。体长1.5至5cm。全身分十五节，每节有组长的足一对，最后一对足特长，足易脱落。触角和脚部很细很长,毒颚很大。蚰蜒属于代谢较低、生长缓慢、繁殖能力差而寿命很长的物种。多在夏秋季节活动，爬行速度较快，常栖居房屋内外阴暗潮湿处，爬行于墙壁、蚊帐、家具、床下，以捕捉小昆虫为食。我国常见的为花蚰蜒，或称大蚰蜒。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-41.jpg" alt="多足害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">马陆</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>千足虫、千脚虫、秤杆虫、香烟虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Diplopoda/Millipedes</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>多足亚门倍足纲动物</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      马陆属于无脊椎动物，倍足纲，暗褐色，背面两侧和步肢赤黄色。头部有触角1对，大颚1对，小颚1对。眼为聚眼。躯干近20节，第1节与头部愈合，第2～4节各有1对步足和1对气孔，自第5节开始，各有2对步足和2对气孔。一般在第5、7、9、10、12、13、15～19节两侧各有臭腺孔1对。<br>
                      马陆昼伏夜出，多栖息潮湿耕地、或枯枝落叶堆、瓦砾、石堆下，行动缓慢，常成群游行。植食性，多食腐殖质，有时也损害农作物。一般白天潜伏，晚间活动。如遇到危害或马陆受到触碰时，会将身体卷曲成圆环形，呈“假死状态”。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="多足害虫"
                                                                                   src="@/assets/img/resources/uploads/2-38.jpg"
                                                                                   style="width: 49%;"> <img alt="多足害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-37.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-38.jpg"> <img alt="多足害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-37.jpg">
                  <p>
                    马陆属于无脊椎动物，倍足纲，暗褐色，背面两侧和步肢赤黄色。头部有触角1对，大颚1对，小颚1对。眼为聚眼。躯干近20节，第1节与头部愈合，第2～4节各有1对步足和1对气孔，自第5节开始，各有2对步足和2对气孔。一般在第5、7、9、10、12、13、15～19节两侧各有臭腺孔1对。<br>
                    马陆昼伏夜出，多栖息潮湿耕地、或枯枝落叶堆、瓦砾、石堆下，行动缓慢，常成群游行。植食性，多食腐殖质，有时也损害农作物。一般白天潜伏，晚间活动。如遇到危害或马陆受到触碰时，会将身体卷曲成圆环形，呈“假死状态”。
                  </p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id == 20" id="main-body20">
      <div id="detail_div_hidePestDetail_30" class="pest-overlay" @click="hidePestDetail()">
        <div id="detail_div_17" class="pest-overlay-content-wrapper" @click.stop="">
          <div class="pest-overlay-container">
            <div id="detail_div_hidePestDetail_31" class="fixed-back-wrapper" @click="hidePestDetail()"><img
              src="@/assets/img/resources/arrow-w-shadow.png" class="back"></div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-25.jpg" alt=""
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蜘蛛</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>网虫、喜子、八脚螅</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Araneae/Spider</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蛛形纲蜘蛛目</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;"></p></div>
                  <div style="display: flex; justify-content: space-between;"><img
                    src="@/assets/img/resources/uploads/2-21.jpg" style="width: 49%;"> <img
                    src="@/assets/img/resources/uploads/3-23.jpg" style="width: 49%;"></div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-21.jpg"> <img
                  src="@/assets/img/resources/uploads/3-23.jpg">
                  <p></p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-26.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蛞蝓</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>鼻涕虫、水蜒蚰</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Slug</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>腹足纲蛞蝓科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      常见蛞蝓像没有壳的蜗牛。成虫伸直时体长30～60mm，体宽4～6mm；梭型，柔软、光滑而无外壳，体表呈暗黑色、暗灰色、黄白色或灰红色。触角2对，暗黑色，下边一对较短，约1毫米，称前触角，有感觉作用；上边一对长约4毫米，称后触角，端部具眼。
                      <br>
                      蛞蝓以成虫体或幼体在作物根部湿土下越冬。5-7月和秋季在田间大量活动为害。野蛞蝓怕光，强光下2-3小时即死亡，多夜间活动，清晨之前又陆续潜入土中或隐蔽处。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-22.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-24.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-22.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-24.jpg">
                  <p>
                    常见蛞蝓像没有壳的蜗牛。成虫伸直时体长30～60mm，体宽4～6mm；梭型，柔软、光滑而无外壳，体表呈暗黑色、暗灰色、黄白色或灰红色。触角2对，暗黑色，下边一对较短，约1毫米，称前触角，有感觉作用；上边一对长约4毫米，称后触角，端部具眼。
                    <br>
                    蛞蝓以成虫体或幼体在作物根部湿土下越冬。5-7月和秋季在田间大量活动为害。野蛞蝓怕光，强光下2-3小时即死亡，多夜间活动，清晨之前又陆续潜入土中或隐蔽处。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-27.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蜗牛</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>蜗娄牛、驼包蜒蚰</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Snail</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>柄眼目蜗牛科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      蜗牛整个躯体包括眼、口、足、壳、触角等部分，身背螺旋形的贝壳，形状，颜色、大小不一。头有四个触角，走动时头伸出，受惊时则头尾一起缩进甲壳中；蜗牛身上有唾涎，能制约蜈蚣、蝎子。<br>
                      蜗牛喜欢钻入疏松的腐殖土中栖息、产卵、调节体内湿度和吸取部分养料，食性杂食性和偏食性并存。喜潮湿但怕水淹。蜗牛具有惊人的生存能力，对冷、热、饥饿、干旱有很强的忍耐性。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-24.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3_copy.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-24.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3_copy.jpg">
                  <p>蜗牛整个躯体包括眼、口、足、壳、触角等部分，身背螺旋形的贝壳，形状，颜色、大小不一。头有四个触角，走动时头伸出，受惊时则头尾一起缩进甲壳中；蜗牛身上有唾涎，能制约蜈蚣、蝎子。<br>
                    蜗牛喜欢钻入疏松的腐殖土中栖息、产卵、调节体内湿度和吸取部分养料，食性杂食性和偏食性并存。喜潮湿但怕水淹。蜗牛具有惊人的生存能力，对冷、热、饥饿、干旱有很强的忍耐性。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-28.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">步甲</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>步行虫、放屁虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Carabidae/Ground beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目步甲科 </p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      步甲成虫体长1～60mm，一般中等大小，色泽幽暗，多为黑色、褐色，常带金属光泽，少数色鲜艳，有黄色花斑。体表光洁或被疏毛，有不同形状的微细刻纹。步甲成虫不善飞翔，多在地表活动，行动敏捷，或在土中挖掘隧道，喜潮湿土壤或靠近水源的地方，白天一般隐藏于木下、落叶层、树皮下、苔藓下或洞穴中，有趋光性和假死现象，多以蚯蚓、钉螺、蜘蛛等小昆虫以及软体动物为食，有些种类只取食动物的排泄物和腐殖质。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-25.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-25.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-25.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-25.jpg">
                  <p>
                    步甲成虫体长1～60mm，一般中等大小，色泽幽暗，多为黑色、褐色，常带金属光泽，少数色鲜艳，有黄色花斑。体表光洁或被疏毛，有不同形状的微细刻纹。步甲成虫不善飞翔，多在地表活动，行动敏捷，或在土中挖掘隧道，喜潮湿土壤或靠近水源的地方，白天一般隐藏于木下、落叶层、树皮下、苔藓下或洞穴中，有趋光性和假死现象，多以蚯蚓、钉螺、蜘蛛等小昆虫以及软体动物为食，有些种类只取食动物的排泄物和腐殖质。</p>
                </div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-29.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">蟋蟀</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>蛐蛐、夜鸣虫、促织</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Gryllidae/Cricket</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>直翅目蟋蟀科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      蟋蟀总科可细分为蟋蟀、灶马、蝼蛄等种类，多数中小型，体长大于3mm；体色变化较大，多为黄褐色至黑褐色，或为绿色、黄色等，多数为杂色。触角丝状，远长于体长。咀嚼式口器，有的大颚发达，强于咬斗。后足发达，善常跳跃。<br>
                      蟋蟀穴居，常栖息于地表、砖石下、土穴中、草丛间，夜出活动，杂食性，吃各种作物、树苗、菜果等。蟋蟀利用翅膀发声，右边翅膀上，有一个像锉样的短刺，左边翅膀上，有像刀一样的硬棘，左右两翅一张一合，相互摩擦就可以发出声响。
                    </p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-26.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3.jpeg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-26.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3.jpeg">
                  <p>
                    蟋蟀总科可细分为蟋蟀、灶马、蝼蛄等种类，多数中小型，体长大于3mm；体色变化较大，多为黄褐色至黑褐色，或为绿色、黄色等，多数为杂色。触角丝状，远长于体长。咀嚼式口器，有的大颚发达，强于咬斗。后足发达，善常跳跃。<br>
                    蟋蟀穴居，常栖息于地表、砖石下、土穴中、草丛间，夜出活动，杂食性，吃各种作物、树苗、菜果等。蟋蟀利用翅膀发声，右边翅膀上，有一个像锉样的短刺，左边翅膀上，有像刀一样的硬棘，左右两翅一张一合，相互摩擦就可以发出声响。
                  </p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-30.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">鳃金龟</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>天鹅绒金龟子、东方金龟子</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Melolonthidae/Cockchafer</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>直翅目鳃金龟科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      鳃金龟通常呈卵圆形或长椭圆形，体色多呈棕、褐至黑褐，有一些色泽比较艳丽。头部口器为唇基遮盖，背面不可见。最显眼的标志就是鳃状的触角，触角9～10节，鳃片部3～8节。大部分后翅发达能飞行。<br>
                      鳃金龟有许多种类为重要的农林害虫、地下害虫，喜食杨、柳、榆、苹果、梨、桑、杏等的叶片。其幼虫（蛴螬）在土内越冬，以腐殖质和嫩根为食，长期危害农林作物。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-27.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-26.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-27.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-26.jpg">
                  <p>鳃金龟通常呈卵圆形或长椭圆形，体色多呈棕、褐至黑褐，有一些色泽比较艳丽。头部口器为唇基遮盖，背面不可见。最显眼的标志就是鳃状的触角，触角9～10节，鳃片部3～8节。大部分后翅发达能飞行。<br>
                    鳃金龟有许多种类为重要的农林害虫、地下害虫，喜食杨、柳、榆、苹果、梨、桑、杏等的叶片。其幼虫（蛴螬）在土内越冬，以腐殖质和嫩根为食，长期危害农林作物。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-31.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">土蝽</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>水知了、鳖蝽</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Cydnidae/Burrower bug</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>异翅亚目土蝽科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      土蝽成虫长7cm或更小，形近卵圆，褐色至黑色，常具金属光泽，个别种类具淡色斑纹，胫节上有刺。多为黑色有光泽，但有的种类带绿或蓝色色调。常称为黑土蝽，会发出难闻的气味。<br>
                      土蝽多中生活于或地表，以植物的根或动物的遗体为食，许多种类为害农作物。有些种类成虫具护卵或护低龄若虫行为。常见于植被、花、果上，尤其是悬钩子上。白纹甲土蝽（Thyreocoris
                      pulicarius）危害芹菜，躯体两侧有白纹。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-28.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-27.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-28.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-27.jpg">
                  <p>土蝽成虫长7cm或更小，形近卵圆，褐色至黑色，常具金属光泽，个别种类具淡色斑纹，胫节上有刺。多为黑色有光泽，但有的种类带绿或蓝色色调。常称为黑土蝽，会发出难闻的气味。<br>
                    土蝽多中生活于或地表，以植物的根或动物的遗体为食，许多种类为害农作物。有些种类成虫具护卵或护低龄若虫行为。常见于植被、花、果上，尤其是悬钩子上。白纹甲土蝽（Thyreocoris
                    pulicarius）危害芹菜，躯体两侧有白纹。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-32.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">猎蝽</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p></p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Reduviidae/Assassin Bug</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>异翅亚目猎蝽科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">猎蝽头部尖、长，在眼后细缩如颈状。触角4节，
                      喙3节，粗短而弯曲，后端放在前胸腹板沟内；常有单眼2个，小盾片呈小三角形；腹部侧接缘发达，明显宽于翅。<br>
                      猎蝽绝大部分为捕食性，以捕食鳞翅目、鞘翅目幼虫等体软而行动不甚活泼的昆虫为多，但亦有捕食体壁坚硬的昆虫（如象甲成虫、蚁类等）和攻击力强的蜂类等者。受惊扰时亦可刺人，引起激烈疼痛。</p>
                  </div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-29.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-28.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-29.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-28.jpg">
                  <p>猎蝽头部尖、长，在眼后细缩如颈状。触角4节， 喙3节，粗短而弯曲，后端放在前胸腹板沟内；常有单眼2个，小盾片呈小三角形；腹部侧接缘发达，明显宽于翅。<br>
                    猎蝽绝大部分为捕食性，以捕食鳞翅目、鞘翅目幼虫等体软而行动不甚活泼的昆虫为多，但亦有捕食体壁坚硬的昆虫（如象甲成虫、蚁类等）和攻击力强的蜂类等者。受惊扰时亦可刺人，引起激烈疼痛。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-33.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">麻皮蝽</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>麻蝽象、麻纹蝽、臭大姐</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Erthesina fullo/Thunberg</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>蝽科麻皮蝽属</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      麻皮蝽体长20～25mm，宽10～11.5mm。头部狭长，侧叶与中叶末端约等长，侧叶末端狭尖。触角5节黑色，第1节短而粗大，第5节基部1/3为浅黄色。头部前端至小盾片有1条黄色细中纵线。前胸背板前缘及前测缘具黄色窄边。胸部腹板黄白色，密布黑色刻点。<br>
                      麻皮蝽成虫飞翔力强，喜于树体上部栖息危害，交配多在上午，可长达约3h，且有假死性，受惊扰时会喷射臭液，早晚低温时常假死坠地，正午高温时则逃飞。有弱趋光性和群集性。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-30.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-29.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-30.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-29.jpg">
                  <p>
                    麻皮蝽体长20～25mm，宽10～11.5mm。头部狭长，侧叶与中叶末端约等长，侧叶末端狭尖。触角5节黑色，第1节短而粗大，第5节基部1/3为浅黄色。头部前端至小盾片有1条黄色细中纵线。前胸背板前缘及前测缘具黄色窄边。胸部腹板黄白色，密布黑色刻点。<br>
                    麻皮蝽成虫飞翔力强，喜于树体上部栖息危害，交配多在上午，可长达约3h，且有假死性，受惊扰时会喷射臭液，早晚低温时常假死坠地，正午高温时则逃飞。有弱趋光性和群集性。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-34.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">叶螨</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>蛛螨、红蜘蛛</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Tetranychidae/Spider mite</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>恙螨目叶螨科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      叶螨体型微小，呈圆形或椭圆形，体长0.2～0.6mm，体侧有黑色斑点，前外侧各有1对眼，体壁柔软，表皮具线状、网状、颗粒状纹或褶皱。背面有成排的背毛，一般不超过16对，呈刚毛状、叶状或棒状。身体颜色或呈红、绿或褐色（多为红色）。会在植物上结一疏松的丝网，所以有时误认为是小蜘蛛。<br>
                      初成长的幼虫由于体型极微细，可以随风扩散，偶然会入侵室内，布满墙面。叶螨是农业生产中的重要害螨，为害棉花、粮食、果树、林木和观赏植物。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-31.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-30.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-31.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-30.jpg">
                  <p>
                    叶螨体型微小，呈圆形或椭圆形，体长0.2～0.6mm，体侧有黑色斑点，前外侧各有1对眼，体壁柔软，表皮具线状、网状、颗粒状纹或褶皱。背面有成排的背毛，一般不超过16对，呈刚毛状、叶状或棒状。身体颜色或呈红、绿或褐色（多为红色）。会在植物上结一疏松的丝网，所以有时误认为是小蜘蛛。<br>
                    初成长的幼虫由于体型极微细，可以随风扩散，偶然会入侵室内，布满墙面。叶螨是农业生产中的重要害螨，为害棉花、粮食、果树、林木和观赏植物。</p></div>
              </div>
            </div>
            <div class="overlay-content" style="width: 100%; height: 100%;">
              <div><img src="@/assets/img/resources/uploads/1-35.jpg" alt="花园害虫"
                        style="width: 100%;"></div>
              <div class="intro-wrapper">
                <div class="capital">隐翅虫</div>
                <div class="intro-row">
                  <div class="subtitle">别名俗称</div>
                  <p>影子虫、青腰虫</p></div>
                <div class="intro-row">
                  <div class="subtitle">外文名</div>
                  <p>Rove beetle</p></div>
                <div class="intro-row">
                  <div class="subtitle">科属</div>
                  <p>鞘翅目隐翅虫科</p></div>
                <div class="intro-desktop">
                  <div class="intro-row mb20">
                    <div class="subtitle">生物特征和习性</div>
                    <p style="line-height: 32px;">
                      隐翅虫多数细长、体小，两侧平行，头、翅和腹尾呈黑色，前胸、腹部及足为橘黄色，形似大蚂蚁，一般不到3mm，最大可达3厘米。大多数种类鞘翅短而厚，长约等于宽，后翅发达，幼虫无翅。有些大型种类有美丽的黑色和黄色，像胡蜂；有的外形和行为均像兵蚂蚁。<br>
                      隐翅虫潮湿环境，栖息的生境多样，林间或森林地表枯枝落叶层、草原、倒伏松树皮下宽松的空间等都可能见到隐翅虫的身影。部分种类体液具有毒性。</p></div>
                  <div style="display: flex; justify-content: space-between;"><img alt="花园害虫"
                                                                                   src="@/assets/img/resources/uploads/2-32.jpg"
                                                                                   style="width: 49%;"> <img alt="花园害虫"
                                                                                                             src="@/assets/img/resources/uploads/3-31.jpg"
                                                                                                             style="width: 49%;">
                  </div>
                </div>
                <div class="intro-mobile mt30">
                  <div class="subtitle" style="padding-bottom: 8px;">生物特征和习性</div>
                  <img src="@/assets/img/resources/uploads/2-32.jpg"> <img alt="花园害虫"
                                                                                                      src="@/assets/img/resources/uploads/3-31.jpg">
                  <p>

                    隐翅虫多数细长、体小，两侧平行，头、翅和腹尾呈黑色，前胸、腹部及足为橘黄色，形似大蚂蚁，一般不到3mm，最大可达3厘米。大多数种类鞘翅短而厚，长约等于宽，后翅发达，幼虫无翅。有些大型种类有美丽的黑色和黄色，像胡蜂；有的外形和行为均像兵蚂蚁。<br>
                    隐翅虫潮湿环境，栖息的生境多样，林间或森林地表枯枝落叶层、草原、倒伏松树皮下宽松的空间等都可能见到隐翅虫的身影。部分种类体液具有毒性。</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Connect_item from '@/components/connect_item'
  import Connect_us from '@/components/connect_us'
  import pest_mes from '@/components/pest_mes'
  import Hot_question from '@/components/hot_question'
  import Pest_advice from '@/components/pest_advice'

  import contains from '@/controller/contains'
  import datas from '@/controller/data'

  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';
  export default {
    name: "PestWikiDetail",
    props: {
      isPhoneSize: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'Connect_item': Connect_item,
      'Connect_us': Connect_us,
      'pest_mes': pest_mes,
      'Hot_question': Hot_question,
      'Pest_advice': Pest_advice
    },


    data() {
      const _this = this;
      return {
        status2:0,
        contains: contains,
        datas: datas,
        showCode1: false,
        left: 200,
        product: {
          product_id: null,
          product_name: null
        },
        pest_voerlay_num: null,
        scrollTop: null,
        equipment: null,
      }
    },
    mounted() {
      console.log()
      var that = this;
      var advantage = 1683;
      var endAdvantage = 2321;
      var kHMix = document.documentElement.clientHeight;//页面可见最大高度
      var hMix = document.body.clientHeight;//页面最大高度
      var x = document.documentElement.scrollTop;
      that.loadData()
      if(x > advantage && x < hMix){
          console.log('我们的优势');
          that.status2 = 1;
      }
      window.addEventListener("scroll",function(e){
        var h = document.documentElement.scrollTop||document.body.scrollTop;
        var newH = h + kHMix;
        var status2 = that.status2;
        if(newH > advantage && newH < endAdvantage){
            if(status2  == 0){
              that.status2 = 1;
              console.log('我们的优势');
          }
        }else{
          that.status2 = 0;
        }
      })
    },
    methods: {
      loadData() {
        let self = this
        let num = self.$route.params.id == 20 ? 3 : 2
        let product_true = {}
        if(!self.datas.pest_wiki_list[self.$route.params.id - num]){
          self.$router.push({path: "/"})
          return
        }

        product_true.product_id = self.datas.pest_wiki_list[self.$route.params.id - num].product_id;
        let product;
        for (let n in self.datas.product_list) {
          if (self.datas.product_list[n].id == product_true.product_id) {
            product = self.datas.product_list[n]
          }
        }
        product_true.product_name = product != undefined ? product.product_name : null
        product_true.title = self.datas.pest_wiki_list[self.$route.params.id - num].title;
        product_true.keywords = self.datas.pest_wiki_list[self.$route.params.id - num].keywords;
        product_true.description = self.datas.pest_wiki_list[self.$route.params.id - num].description;
        product_true.productName = self.datas.pest_wiki_list[self.$route.params.id - num].product_name;
        self.product = product_true
        // self.equipment = store.app.context.deviceType.type
      },
      touchstart(e){
        var x = e.targetTouches[0].pageX;
        this.pagex = x;
      },

      getHotQuesion($event) {
        let name = $event.currentTarget;
        // console.log($event)
        if (name.className == 'faq-cell') {
          name.classList.add('expanded')
          $(name).find('.icon').hide().eq(1).show()
        } else {
          name.classList.remove('expanded')
          $(name).find('.icon').hide().eq(0).show()
        }
      },
      showPestDetail(num) {
        this.pest_voerlay_num = num
        $('.pest-overlay').eq(0).show()
        $('.pest-overlay').animate({
          scrollTop: 0
        }, 2000);
        $('.pest-overlay .overlay-content').hide()
        $('.pest-overlay .overlay-content').eq(num).show();
      },
      hidePestDetail() {
        this.pest_voerlay_num = null
        $('.pest-overlay').hide()
        $('.pest-overlay .overlay-content').hide();
      },
      getMesDetail(num, title) {
        if ($('.expandable-border-cell').eq(num).attr('class') == 'expandable-border-cell') {
          $('.expandable-border-cell').eq(num).addClass('expanded');
          window.localStorage.setItem('scrollTop', document.documentElement.scrollTop)
        } else {
          $('.expandable-border-cell').eq(num).removeClass('expanded');
          document.documentElement.scrollTop = window.localStorage.getItem('scrollTop')
        }

      },
      showMore() {
        if ($('.pest-intro-wrapper').attr('class') == 'pest-intro-wrapper') {
          $('.pest-intro-wrapper').addClass('expanded')
        } else {
          $('.pest-intro-wrapper').removeClass('expanded')
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .pest-type.flex-row.not-clickable {
    background-color: gray !important;
  }

  /deep/ .contact-us-section .slider-wrapper .van-swipe__indicators {
    display: none;
  }

  /deep/ .pest-faq-section .faq-cell-wrapper .faq-cell .faq-cell-answer .cell-img-wrapper img.pic {
    max-height: 263px;
    max-width: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/views/pest_wiki/detail.vue